export default {
  system: {
    name: 'Seller',
    home: 'Dashboard',
    signOut: 'Sign Out',
    myAccount: 'My Account',
    systemLanguage: 'Language',
    login: 'Login',
    passwordLogin: 'Password Login',
    smsLogin: 'Code Login',
    sendCode: 'Get Code',
    retrySending: 'Get Again',
    loginTips: 'First-time users or unverified numbers must use password login ',
    loggedOut: 'Your session has expired. Please log in again or return to homepage ',
    confirmLogout: 'Confirm Logout',
    welcomeBack: 'Welcome Back',
    systemName: 'HURIX',
    title: 'HURIX Seller Central',
    NoMatchingData: 'No data',
    specificationExists: 'Please select the Specification Item first. ',
    ProductSpecificationIdentifier: 'SKU is the smallest inventory unit used to distinguish different specifications (color / size / capacity, etc.). It is recommended to fill in the merchant\'s internal specification code for inventory management, price setting, and order shipping.',
    PleaseUploadPictures: 'Upload Images',
    specificationImageRequired: 'Image required for this specification ',
    specificationsEmpty: 'Specifications cannot be empty',
    noPermission: 'You do not have permission to access.',
    noIp: 'IP information not obtained',
    sureLogout: 'Are you sure log out of the system ? ',
    forgotPass: 'Forgot Password',
    Expired: 'Expired',
    unreadSystemNotifications: 'Unread notifications - Click here ',
    failedIdentityInformation: 'Failed to retrieve identity information. Please contact the platform support for assistance.',
    PrivacyPolicy: 'Privacy Policy',
    reconnect: 'Attempting to reconnect...',
    ByContinuing: 'By continuing, you agree to HURIX\'s',
    AlreadyHaveAccount: 'Already have an account ? Sign in',
    loginAccount: 'Login account',
    enterEmailorMobile: 'Enter mobile number or email address',
    comingSoon: 'Coming Soon',
    NoData: 'No Data',
    enter: "Enter Store",
    select: "Select store to login",
    accountLogin: 'Account Login',
  },
  home: {
    dashboardTitle: 'Real-time Business Monitoring · Data-driven Decisions',
    statPendingShipment: 'Pending Shipment',
    statPendingReceipt: 'Pending Receipt',
    statBooking: 'Booking',
    statAfterSalesReview: 'After-sales Review',
    statSpu: 'SPU Categories',
    statLowStockSku: 'Low-stock SPU',
    statExpiring: 'Expiring Products',
    statLowRating: 'Low-rating Products',
    orderVolumeTrendTitle: 'Order Volume Trend',
    gmvTrendTitle: 'GMV Trend Analysis',
    report: 'Report',
    realtimeOrder: 'Real-time Orders',
    preOrder: 'Pre-orders',
    loading: 'Loading...',
    reportDetailTitle: 'Report Details',
    reportDetailSubtitle: 'Central view of key metrics: store order volume & GMV.',
    tabOrderTrend: 'Order Volume Trend',
    tabGmvTrend: 'GMV Trend Analysis',
    colDate: 'Date',
    colRealtimeOrder: 'Real-time Orders',
    colPreOrder: 'Pre-orders',
    colRealtimeGmv: 'Real-time GMV',
    colPreGmv: 'Pre-order GMV',
    query: 'Query',
    exportSuccess: 'Exported',
    dateInvalid: 'Please select a valid date range',
    backOrder: 'Back Order',
    pendingShipmentOrder: 'Pending Shipment Orders',
    commodityInventory: 'Inventory below 10',
    ReservationOrder: 'Pre-Orders',
    inventoryAlert: 'Inventory Alert',
    orderInformation: 'Order Detail',
    quantityOfGoods: 'Quantity of Goods',
    remainingInventory: 'Remaining Inventory',
    settlementAmount: 'Historical Earnings',
    "newbieTask": "Newbie Task: Publish a Product",
    title: 'Congratulations on completing the new store registration. To better enjoy the sales benefits of  HURIX, please publish your products as soon as possible.',
    checkTutorial: 'Check the tutorial',
    "publishNow": "Publish Now",
    "newlyAddedProduct": "Add product",
    "priceDeclaration": "Price declaration",
    "officialSale": "Official sale",
    "deliverToConsumers": "Deliver to consumers",
    "returnReview": "Return Review",
    "pendingAfterSales": "Pending After-sales",
    cancelOrderPending: 'Cancel order pending processing',
    "logisticsException": "Logistics Exception",
    "pendingViolation": "Pending Violation",
    "operatingData": "Operating Data",
    "realTime": "Real-time",
    "last7Days": "Last 7 Days",
    "last30Days": "Last 30 Days",
    moreData: 'More Data',
    "transactionAmount": "Transaction Amount",
    "transactionVolume": "Transaction Volume",
    "numberOfCustomers": "Number of Customers",
    "productVisitors": "Product Visitors",
    "productClicks": "Product Clicks",
    "refundOrders": "Refund Orders",
    "storeExpenditure": "Store Expenditure",
    "withdrawAmount": "Withdrawable Amount",
    "yesterday": "Yesterday",
    withdraw: 'Withdraw',
    "flat": "Flat",
    inventoryChangeTrend: "30-day Inventory Change Trend",
    "realTimeOrderAmount": "Real-time Order Transaction Amount",
    "realTimeOrderVolume": "Real-time Order Transaction Volume",
    "realTimeOrderCustomers": "Real-time Order Transaction Customers",
    "reservationOrderAmount": "Reservation Order Transaction Amount",
    "reservationOrderVolume": "Reservation Order Transaction Volume",
    "reservationOrderCustomers": "Reservation Order Transaction Customers",
    colTotal: 'Total',
  },
  table: {
    filter: 'Filter',
    dataList: 'Data List',
    id: 'ID',
    function: 'Function',
    viewAddress: 'View Address',
    productImage: 'Image',
    total: 'Total x',
    previous: 'Previous',
    next: 'Next',
    pageSize: '/page',
    currentFilter: "Current Filter",
    totalCount: "Total 1981 items",
  },
  button: {
    continue: 'Continue',
    or: 'or',
    save: 'Save',
    create: 'Create',
    saveAll: 'Save All',
    addnew: 'Add New',
    search: 'Search',
    reset: 'Reset',
    more: 'More',
    download: 'Download',
    delete: 'Delete',
    upload: 'Upload',
    update: 'Update',
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    submit: 'Submit',
    import: 'Import',
    print: 'Print',
    edit: 'Edit',
    goEdit: 'Go Edit',
    clear: 'Clear',
    details: 'Details',
    push: 'Push',
    view: 'View',
    viewDetails: 'View Details',
    log: 'Log',
    draftBox: 'Drafts',
    notifyConsignee: 'Notify Consignee',
    browse: 'Browse',
    Addlines: 'Add lines',
    Clearalllines: 'Clear all lines',
    SendEmail: 'Send Email',
    sendNotification: 'Send Notification',
    SaveCostOnly: 'Save(Cost Only)',
    EmailCreditNote: 'Email Credit Note',
    ExportReport: 'Export a Report',
    EmailReport: 'Email a Report',
    Calculate: 'Calculate',
    add: 'Add',
    addGoodsReturn: 'Add For Goods Return',
    Reduce: 'Reduce',
    batchAdd: 'Bulk Add',
    BatchDelete: 'Bulk Delete',
    back: 'Back',
    retry: 'Retry',
    next: 'Next',
    generateSalesReport: 'Generate Sales Report',
    generateCustomerReport: 'Generate Customer Report',
    addNote: 'Add note',
    hide: 'Hide',
    show: 'Show',
    history: 'History',
    export: 'Export',
    refresh: 'Refresh',
    generate: 'Generate',
    preview: 'Preview',
    select: 'Select',
    PreviousStep: 'Previous Step',
    NextStep: 'Next Step',
    calculate: 'Calculate',
    bulkUpload: 'Bulk Upload',
    filter: 'Filter',
    copy: 'Copy',
    verify: 'Verify',
    complete: 'Complete',
    AddUser: 'Add User',
    apply: 'Apply',
    Expand: 'Expand',
    Collapse: 'Collapse',
    viewAll: 'Show all',
    modify: 'Modify',
    exportProductInfo: 'Export Product',
    confirmAndGenerateReturnWaybill: 'Confirm & create return waybill',
  },
  permission: {
    role: 'Role',
    roleName: 'Role Name',
    status: 'Status',
    roleType: 'Role Type',
    assignmentsMenu: 'Assignments Menu',
    enable: 'Enabled',
    disable: 'Disabled',
  },
  ums: {
    userName: 'User Name',
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    resetPassword: 'Reset Password',
    createdTime: 'Created Time',
    lastLoginTime: 'Last Login Time',
    lastUpdateTime: 'Update Time',
    notes: 'Notes',
    description: 'Description',
    administratorType: 'Administrator Type',
    createdBy: 'Created By',
    yes: 'Yes',
    no: 'No',
    addRole: 'Add Role',
    editRole: 'Edit Role',
    menuName: 'Menu Name',
    internationalizationVariables: 'Internationalization Variables',
    menuOrder: 'Menu Order',
    menuIcon: 'Menu Icon',
    componentName: 'Component Name',
    menuLevel: 'Menu Level',
    firstLevel: 'First Level',
    secondLevel: 'Second Level',
    thirdLevel: 'Third Level',
    showOrNot: 'Show Or Not',
    sort: 'Sort',
    superiorMenu: 'Superior Menu',
    menuType: 'Menu Type',
    show: 'Show',
    hide: 'Hide',
    platform: 'Platform',
    buyer: 'Buyer',
    seller: 'Seller',
    system: 'System',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    addUser: 'Add User',
    editUser: 'Edit User',
    check: 'Check',
    verificationFailed: 'Verification failed, please login again',
    authWay: 'Verification',
    byEmail: 'Email',
    byPhone: 'Phone',
    code: 'Code',
    usernameTaken: 'This username is already registered.',
    emailTaken: 'This email is already registered.',
    phoneTaken: 'This  phone number is already registered.',
    userNameLimit: 'Only letters, numbers, and underscores are allowed. Please avoid using offensive or inappropriate terms',
    userNameLimit2: 'Usernames cannot contain the sensitive word "HURIX"',
    userNameLimit3: 'Please enter a username between 6 and 20 characters',
    passwordLimit: 'Please use at least three types of characters from the following: uppercase letters, lowercase letters, numbers, and special characters. Special characters include!@#$%^&*()_+-=[]{};:,.?~`',
    passwordLimit2: 'Contains a special character that is not allowed',
    newPasswordLimit3:'It must include at least two of the following: letters, numbers and symbols',
    newPasswordLimit2:'The length is 8 to 20 characters',
    newPasswordLimit:'Spaces cannot be included',
    None: 'None',
    isAdmin: 'Is administrator',
    setUpEmailPass: 'Please set up your email and password.',
    phoneRegisteredAsOperator: 'This phone number is already registered as an operator account.',
    newPwdTip: "New password (8-20 characters)",
    reEnterNewPwd: "Re-enter new password",
  },
  placeholder: {
    input: 'Please Enter',
    select: 'Please Select',
    selectWarehouse: 'Please Select Warehouse',
    selectCourierBrand: 'Please select carrier',
    length: 'Length',
    width: 'Width',
    height: 'Height',
    inputProductNameKeywords: 'Enter Product Name Keywords',
    inputRecipient: 'Please Enter Recipient Email or Phone Number',
    inputOrderSn: 'Enter Order Number',
    from: "From",
    to: "To",
    minPrice: "Min. price",
    maxPrice: "Max price",
    recipientContact: "Enter recipient email / recipient phone number",
    operatorKeyword: "Enter Operator Keywords",
    selectSettleCycle: 'Please select settlement cycle',
    inputOrderNumber: 'Enter order number',
    orderNoKeyword: "Enter order number",
    productNameKeyword: "Enter product name keyword",
    merchantSkuKeyword: "Enter merchant SKU keyword",
    trackingNoKeyword: "Enter tracking number",
    returnNoKeyword: "Enter return number",
    inputOrderReturnNo: "Enter Order No. / Return No.",
    inputLogisticsNo: "Enter Return Tracking Number",
  },
  shop: {
    approved: 'Approved',
    unApproved: 'Unapproved'
  },
  message: {
    title: 'Message',
    consignmentQueryMsg: 'Confirm the deletion Warehousing - Goods The data?',
    consignmentQueryMsg1: 'Confirm the deletion',
    consignmentQueryMsg2: 'The data',
    packingTierMsg: 'Confirm the deletionpackagetypeThe data?',
    packingTierMsg1: 'Confirm the deletion',
    packingTierMsg2: 'The data',
    locationMsg: 'Confirm the deletion Position The data?',
    locationMsg1: 'Confirm the deletion',
    locationMsg2: 'The data',
    appManagementMsg: 'Delete it?',
    addedSuccessfully: 'Successfully Added',
    addedFailed: 'Add Failed',
    deleteSucceeded: 'Successfully Deleted',
    deleteFailed: 'Delete Failed',
    uploadSuccessfully: 'Successfully Upload',
    uploadFailed: 'Upload Failed',
    copySuccessfully: 'Successfully Copied!',
    copyFailed: 'Copy Failed',
    saveSuccess: 'Successfully Saved',
    saveFailed: 'Save Failed',
    sendEmail: 'Email has been sent successfully',
    sendFailed: 'Send Failed',
    exportFailed: 'Export Failed',
    sendCode: 'The verification code has been successfully sent',
    operateSuccess: 'Operated Successfully',
    loginSuccess: 'Login Successfully',
    operateFailed: 'Operate Failed',
    systemError: 'System Error Please report to the administrator.',
    noPermissions: 'Sorry, you do not have permission to perform this operation',
    confirmSendEmail: 'Are you sure you want to send the Book PMC Collection email?',
    recipients: 'Recipients:',
    duplicate: 'Email Cc:',
    sendEmailTip: 'Are you sure you want to send the email ?',
    information: 'Information',
    deleteInformation: 'Are you sure you want to delete this data ?',
    confirmInformation: 'Do you want to confirm submission ?',
    modifyStatus: 'Do you want to modify this status ?',
    duplicatePhoneNumber: 'Duplicate Phone Number',
    fileTypeMustBeJPGOrPng: 'The file type must be image',
    fileTypeMustBeJPGOrPngOrVideo: 'The file type must be image or video',
    ratioOfImage1Is1: 'The aspect ratio of the image should be 1:1',
    ratioOfVideo1Is1: 'The aspect ratio of the video should be 1:1',
    uploadResults: 'Upload Results',
    warehouseNameAlreadyExists: 'Warehouse name already exists',
    warehouseIsPending: 'The warehouse is in a pending review status and duplicate binding is not allowed',
    unsavedChangesTips1: 'You have unsaved changes. Do you want to save them?',
    unsavedChangesTips2: 'Save your draft before leaving.',
    phoneRequired: 'Please fill in your phone number first.',
    areYouSure: 'Are you sure ',
    pleaseWait: 'Processing, please wait...',
    cannotExceedMB: 'The file size cannot exceed 10MB.',
    verifyReturnAddressCorrect: 'Operation failed. Please verify the return address or select another return carrier.',
    "uploadText": "Click or drag files to the dashed area to upload. ",
    "errorMessage1": "Only xlsx format files are allowed!",
    trackingNumberLengthAndDigitRule: 'Enter a 5-50 character tracking number containing at least one digit',
    trackingNumberCharacterRule: 'Only letters, digits, and nonconsecutive hyphens (-) are allowed; do not start or end with a hyphen',
    multipleParcelsNote: 'If this tracking number corresponds to multiple parcels, please indicate this in the notes',
    supportedMediaFormats: "Only images and videos in m4v, mp4, mkv, mov, 3gp, webm formats are supported for upload",
    confirmSubmission: 'Confirm submission',
    noticeTitle: "Alert",
    goodsShippedTip: "Goods have been dispatched/shipped. Please double-check whether the approval is passed.",
    orderCancelTip: "The system will cancel the HURIX order and process automatic refund. Please notify the warehouse as soon as possible to intercept the shipment.",
    verifyCodeTip: "Please enter verification code",
    phoneTip: "Please enter phone number",
    emailTip: "Please enter email",
    deleteSkuTips: 'Deleting this information will permanently remove all associated variants and data. This action cannot be undone.',
  },
  rulesTips: {
    required: 'This field is required.',
    requiredAndNum: 'This field is required and it is number type.',
    noEmpty: "It can't be empty.",
    enterChar: 'Please enter 3 or more characters.',
    enterChar2: 'Please enter 2 or more characters.',
    enterSearch: 'Enter keywords to search categories...',
    emailTips: 'Please enter a valid email address.',
    urlTips: 'Please enter a valid URL.',
    addressLine1: 'The input length cannot exceed 35 characters',
    notLessOne: 'Not less than 1',
    notLessZero: 'Can not be less than 0',
    enterPasswordAgain: 'Please enter your password again',
    passwordInconsistent: 'The two passwords are inconsistent',
    passwordLength: 'Please enter a password between 8 and 20 characters',
    noSpace: 'Password cannot contain spaces',
    passwordComplexity: 'must contain at least 3 of the following: uppercase letters, lowercase letters, numbers, symbols',
    twoToOneHundredAndForty: 'The length ranges from 2 to 140 characters',
    fileSizeLess10: 'The file size must be less than 10MB.',
    requiredFields: 'Required fields cannot be empty',
    loginAgain: 'This operation will force you to log out and log back in to the system',
    enterPlatformPrice: 'Please enter the HURIX selling price',
    enterMarketReferencePrice: 'Please enter the market reference price',
    enterReferenceLink: 'Please enter the reference link',
    enterWeight: 'Please enter weight',
    postcodeTip: 'Invalid UK postcode format. Example: SW1A 1AA',
    invalidData: 'Invalid data. Please check your input.',
    correctPhoneNumber: 'Please enter the correct mobile phone number format',
    emailNotRegistered: 'This email is not registered',
    phoneNumberNotRegistered: 'This phone number is not registered',
    emailAlreadyExists: 'The email already exists',
    userNameExists: 'The user name already exists',
    VATNoAlready: 'This VAT No. has already been registered',
    getCodeFirst: 'Please get the verification code first',
    atLeastOneDocument: "Please upload at least one document",
    QQCannotUsed: 'QQ email addresses cannot be used',
    maximumChar: 'Maximum 20 characters. ',
    nickNameIsRequired: 'Nickname is required. ',
    noSpecialChars: 'Special characters are not allowed.',
    onlyPDF: 'Only PDF files are allowed',
    onlyImageOrPDF: 'Only Image or PDF files are allowed',
    requiredCnCertificateUsername:'Please enter the Chinese country certificate username',
    requiredUkCertificateUsername:'Please enter the UK country certificate username',
    inputProductName: "Please enter product name",
    inputProductSellingPoint: "Please enter product selling points",
    inputProductCategory: "Please select product category",
    inputProductWeight: "Please enter product weight",
    inputLength: "Please enter length",
    inputWidth: "Please enter width",
    inputHeight: "Please enter height",
    inputMainImage: "Please upload main image",
    specItem: "Please enter specification item",
    specValue: "Please enter specification value",
    hurixPrice: "Please enter HURIX selling price",
    marketReferencePrice: "Please enter market reference price",
    referenceLink: "Please enter reference link",
    warehouseName: "Please select warehouse name",
    merchantSku: "Please enter merchant SKU",
    stockNum: "Please enter stock quantity",
    expireTime: "Please enter expiry date",
    supplyPrice: "Please enter supply price",
    productDetail: "Please enter product details",
    selectFreeShipping: "Please select free shipping option",
    selectSplitPackage: "Please select whether split shipment is available",
    packageWeight: "Please enter package weight",
    selectWarehouseSystem: "Please select warehouse system",
    inputAppKey: "Please enter AppKey",
    inputAppSecret: "Please enter AppSecret",
    selectWarehouseCode: "Please select warehouse code",
    shippingFee: "Please enter shipping fee",
    recipientName: "Please enter recipient name",
    selectCountry: "Please select country",
    postcode: "Please enter postcode",
    inputAddressLine1: "Please enter address line 1",
    cityTown: "Please enter town/city",
    cancelReason: "Please enter cancellation reason",
    remark: "Please enter remarks",
    refundAmount: "Please enter refund amount",
    reason: "Please enter reason",
    withdrawAmount: "Please enter withdrawal amount",
    confirmNewPwdTip: "Please re-enter new password",
    operatorName: "Please enter operator name",
    selectRole: "Please select role",
    accountInputTip: "Please enter mobile number or email address",
    password: "Please enter password",
    inputDetailAddress: "Please enter detailed address",
  },
  product: {
    templateSteps: ['Search Product/Category/SSIN', 'Choose Product', 'Custom Attributes & Stock', 'Confirm Add To Store'],
    blankForm: 'Blank Form',
    recommendedCategories: 'Recommended Categories',
    importProductTemplate: 'Import Product Template',
    retailInfo: 'Retail and wholesale, logistics and distribution',
    batchUpload: 'Add Products via Bulk Upload',
    selectProductType: 'Please select the product type',
    basicInfo: 'Basic Information',
    basicInfoTips: 'Fill in the basic information of the product, including name, selling points, category, brand, weight, size and other core attributes. Ensure the information is accurate and complete, which helps with product exposure and conversion.',
    commodityTradingInfo: 'Product Trading Information',
    productSpecification: 'Product specifications and pictures',
    productDesc: 'Product Details',
    productLogisticsInfo: 'Product logistics information',
    shipping: 'Shipping',
    otherInfo: 'Other information',
    isShippingFree: 'Is shipping free',
    packageWeight: 'Package weight',
    packageDimensions: 'Package dimensions',
    estimatedShippingCost: 'Estimated shipping cost',
    estimatedShippingCostTips: 'Estimated shipping cost is a reference based on product weight, dimensions, and destination. Actual shipping costs may vary depending on logistics provider, delivery method, and other factors.',
    shippingNotes: 'Mainland areas include England, Wales, and Scotland, while remote areas refer to Northern Ireland and the Scottish Highlands. When calculating seller categories, we consider both collection and delivery volumes; however, delivery parcels will always be charged according to the delivery rate schedule.',
    remoteAreas: 'Remote areas include the following regions:',
    category: 'Category',
    price: 'HURIX selling price',
    weight: 'Product Weight',
    dimensions: 'Product size',
    quantity: 'In Stock',
    warehouseInfo: 'Managed Inventory',
    bottomPrice: 'Bottom Price',
    referencePrice: 'Market Reference Price(VAT included)',
    referenceLink: 'Reference Link',
    profit: 'Discount Rate(Relative to Market Reference Price)',
    lastCoilQuantity: 'Min Circle Qty',
    productName: 'Product Name',
    listingStatus: 'Listing Status',
    productStatus: 'Product Status',
    productImage: 'Product Image',
    skuImage: 'SKU Image',
    salesVolume: 'Sales Volume',
    totalStock: 'Total Stock',
    stock: 'Stock',
    availableStock: 'Available Stock',
    lockInventory: 'Locked Stock',
    productStock: 'Product Stock',
    stockLog: 'Stock Log',
    verifyStatus: 'Verify Status',
    pendingApproval: 'Reviewing',
    reviewRejected: 'Rejected',
    selectProductCategory: 'Product Basic Information',
    fillInProductDetails: 'Product Details',
    fillInSpec: 'Product Specifications',
    publishedSuccessfullyMsg: 'Product information has been submitted!',
    publishedSuccessfullyTip: 'The system is currently reviewing your product, Please be patient.',
    viewProductStatus: 'Go check the product review status',
    youCanAlso: 'You can also',
    goOn: 'Go on',
    publishProduct: 'Publish Product',
    productReviewList: 'Product Verify List',
    productPrice: 'Product Price',
    sellingPoint: 'Selling Point',
    productBrand: 'Product Brand',
    brandName: 'Brand Name',
    brandIcon: 'Brand Icon',
    unit: 'Product Unit',
    unitExplain: 'How the product to be sold, i.e. per piece, per box, per  set',
    hostGraph: 'Main Image',
    uploadFile: 'Upload File',
    fileToWithin10MB: 'Please compress the file to within 10MB',
    rangeWith: 'The image aspect ratio should be 1:1, with a tolerance of up to 10%',
    supportFiveFiles: 'Supports uploading up to 5 files',
    customSpecificationItems: 'Custom specification items',
    addSpecificationItems: 'Add Specification Items',
    specificationItem: 'Specification Item',
    specificationItemExplain: 'Categories of product specifications (e.g., Color, Size, Material), defining the types of specs to fill in',
    addSpecificationImages: 'Add Specification Images',
    specificationValue: 'Specification Values',
    specificationValueExplain: 'Specific options under each category (e.g., "Red" for Color, "M" for Size), used to differentiate product variants',
    detailedSpecifications: 'Detailed Specifications',
    verifyMaterials: 'Verification Documents',
    productInfoVerifyTip: 'Please provide inventory certification materials and market price verification (third-party links/images, etc.) to ensure the authenticity and availability of product information.',
    previousStep: 'Previous Step',
    nextStep: 'Next Step',
    saveProduct: 'Completed',
    saveDraft: 'Save Draft',
    saveTemplate: 'Save Template',
    reason: 'Reason',
    pass: 'Pass',
    refuse: 'Refuse',
    editInventory: 'Edit Inventory',
    editProductInformation: 'Edit Product Information',
    skuNumber: 'SKU Count',
    sellingPrice: 'Selling Price',
    descSelling: 'Currently on sale, orders can be placed normally',
    descSoldOut: 'Inventory cleared, temporarily unavailable for purchase',
    descDelist: 'Withdrawn from the store, invisible to buyers',
    descApproved: 'Product has passed review and is ready for listing',
    descPending: 'Product is being reviewed, please wait patiently',
    descRejected: 'Product did not pass review, please revise and resubmit',
    descDefault: 'Manage your products here',
    warehouseDescApproved: 'Warehouse has passed review and can be selected when listing products',
    warehouseDescPending: ' Warehouse is being reviewed, please wait patiently. It can be linked to products only after approval',
    warehouseDescRejected: ' Warehouse did not pass review. Please revise and resubmit based on the feedback. It can be linked to products only after approval',
    draftDesc: 'Drafts will not be automatically submitted for review. Please confirm all product information is correct before manually submitting',
    editBrand: 'Edit Brand',
    addBrand: 'Add Brand',
    brandTip: 'Note: Submitted brand data cannot be changed. Please verify before submission.',
    reasonForRejection: 'Rejection Reason',
    warehouseLocation: 'Warehouse Location',
    brandInitial: 'Brand Initial',
    brandLogo: 'Brand Logo',
    brandZoneLargePicture: 'Brand Zone Large Picture',
    brandStory: 'Brand Story',
    classificationName: 'Classification Name',
    editCategory: 'Edit Category',
    addCategory: 'Add Category',
    categoryParent: 'Category Parent',
    classificationLevel: 'Classification Level',
    expirationDate: 'Expiry Date',
    expirationDateTip: 'Changing the expiry date will impact orders and may cause cancellations. You are fully responsible for all outcomes.',
    inventoryAdjustmentWarning: 'If your inventory adjustments affect orders and result in transaction cancellations, you are fully responsible for all consequences.',
    localTimeAtWarehouse: 'Expiry date of product stored in the warehouse',
    cargoOwner: 'Goods Owner',
    bindWarehouse: 'Bind Warehouse',
    addAndBindWarehouse: 'Add Warehouse',
    businessType: 'Business Type',
    soldTo: 'Inventory Location',
    list: 'Listed',
    delist: 'Delisted',
    less30Days: 'The difference in days between the warehouse expiration time and the product release time is less than 30 days',
    warehouseHasBeenSelected: 'The warehouse has already been selected',
    warehouseChangeTip: '【Seller SPU, SKU】Do you want to update?',
    spu: 'Seller SPU',
    shipperSku: 'Seller SKU',
    productCommissionByThePlatform: 'Platform Commission Rate',
    expired: 'Expired',
    unexpired: 'Unexpired',
    expiredStatus: 'Expired Status',
    alreadyBooked: 'Already Booked',
    stockTip: 'Please verify your modification information',
    pendingTips1: '48 hours review (by ',
    pendingTips2: '). For questions, contact the admin.',
    selectedCategory: 'Selected: ',
    selectCategory: 'Select a Category',
    preview: 'Preview',
    cumulativeEvaluation: 'Evaluation',
    strip: 'Strip',
    num: 'NO.',
    kg: 'KG',
    discount: 'Discount',
    retailPrice: 'Market Price',
    buyNow: 'Buy Now',
    Reservation: 'Pre-order Now',
    productTitleTem: 'i.e. Brand + Model + Core Function + Application Scenario\n(Apple iPhone 14 Pro 256GB 5G Smart Phone Deep Space Black)\n(Nike Air Max 270 Sports Shoes Unisex Shock Absorption Breathable)',
    productNameTips: 'Clearly and accurately describe the product, include core attributes and features, use concise language, no more than 255 characters',
    productSellingPoint: 'i.e. Sales/reputation + Core function + Application scenario + Unique advantage\n(Online sales of 24000+ transactions, ergonomic design, comfortable for long sitting, suitable for gaming/office)\n(German imported material, 304 stainless steel, lifetime warranty, food-grade safety)',
    sellingPointTips: 'Highlight the core advantages and unique selling points, attract buyers\' attention, promote conversion, no more than 500 characters',
    categoryTips: 'Choose the correct product category to help buyers find your product quickly, improve exposure and conversion rate',
    brandTips: 'Fill in the brand name of the product, ensure the brand information is accurate, which helps build brand image and improve product credibility',
    weightTips: 'Fill in the actual weight of the product, unit can be grams(g) or kilograms(kg), ensure the weight information is accurate to avoid logistics problems',
    dimensionsTips: 'Fill in the actual dimensions of the product, including length, width and height, unit is centimeters(cm), ensure the dimension information is accurate to avoid logistics problems',
    spuTips: 'SPU is a unified product identifier. It is recommended to fill in the merchant\'s internal product code for unified product management, inventory tracking, and classification of multi-specification products.',
    hostGraphTips: 'Aspect ratio: 1:1. File size limit: 10 MB. Format: JPG/PNG/GIF. Size: 800×800px',
    specTips: 'Specification items are basic attributes of the product, such as color, size, etc., used to distinguish different SKUs. Specification values are specific contents of specification items, such as red, blue, M size, L size, etc. Filling requirements: At least one specification item is required, each specification item must have at least one specification value, each specification value under the first specification item must upload a corresponding image, and a maximum of five specification items are supported.',
    fillInSpecTips: 'Specification items are basic attributes of the product, such as color, size, etc., used to distinguish different SKUs. Specification values are specific contents of specification items, such as red, blue, M size, L size, etc.',
    referenceLinkTips: 'Reference link is used to verify product price, it is recommended to fill in the product link of mainstream e-commerce platforms',
    warehouseNameTips: 'Select the warehouse where the product is stored to ensure accurate inventory information',
    detailsTips: 'Product details are important content to show product features and advantages to buyers, it is recommended to fill in details',
    isReturnableTips: 'Set whether the product supports returns, which affects buyers\' purchase decisions',
    autoShelvesTips: 'Whether to automatically list the product after approval, saving operation time',
    isSplitTips: 'Whether to support shipping the product in multiple packages, suitable for large items',
    packageWeightTips: 'Package weight refers to the total weight of the product after packaging, which affects logistics cost calculation',
    packageDimensionsTips: 'Package dimensions refer to the length, width and height of the product after packaging, which affects logistics cost calculation and transportation method selection',
    selectProductTemplate: 'Please select the product template',
    searchByProductOrBrand: 'Search by Category, Product, or SSIN',
    noSku: 'No SKU information available',
    noChange: 'You have made no changes. ',
    videoErr: 'Unable to read video information. ',
    imageCropping: 'Image Cropping',
    isAutoList: 'Auto-listed Upon Approval',
    canBeReturned: 'Buyer returns',
    returnsAccepted: 'Return Accepted',
    noReturns: 'No Return',
    operationType: 'Operation Type',
    ownerShipmen: 'Owner Shipment',
    resellerReturn: 'Reseller Return',
    ownerInventoryAdjustment: 'Owner Inventory Adjustment',
    expiredInventoryPurge: 'Expired inventory purge',
    previousStock: 'Previous Stock',
    nextStock: 'Modified Stock',
    selectMethodCreatedProduct: 'Please select the method for creating the product',
    unsubmittedProduct: 'Detected that you have an unsubmitted product draft,Do you want to ',
    continueEditDraft: 'continue editing the draft ?',
    selectProductTem: 'Add existing products on the platform',
    createNewProduct: 'Manually Add Product',
    noMatchProduct: 'No matching product template found',
    enterProductName: 'Please enter the Product Name or Brand Name. ',
    templateSelected: 'Template selected',
    requiredToProvideMarketPrice: 'The industry average price or mainstream platform prices for similar products can serve as pricing benchmarks for sellers.',
    requiredToProvideInventoryProofMaterials: 'Merchants are required to provide inventory proof materials',
    specNameExists: 'The specification name cannot be repeated',
    specValueExists: 'The specification value cannot be repeated',
    editStockTip: 'If your inventory adjustments affect an order and lead to the cancellation of transaction, you will be fully liable for all consequences.',
    editProduct: 'Edit Product',
    carrier: 'Carrier',
    transitTime: 'Transit Time',
    weightLimit: 'Weight Limit',
    basicFreight: 'Base Rate',
    surcharge: 'Surcharges',
    warning1: 'The product is under review. Please go to the corresponding review process for View. ',
    warning2: 'The product is under review Rejected. Please go to the corresponding review process for editing. ',
    WarehouseAddress: 'Warehouse Address',
    deleteSku: 'Are you sure to delete this SKU? ',
    isSplit: 'Split Allowed (≤30kg)',
    splitTip: 'Single-package weight limit: 30kg max.',
    downloadTemplate: 'Download Template',
    upload: 'Product Import',
    uploadNotice: 'Import in progress. Please check your inbox for the results.',
    uploadReminder: 'Please add your warehouse first',
    batchProductImport: 'Bulk Add Products',
    downloadConfirm: 'The product template for the selected category will be downloaded. Do you want to proceed?',
    supplyPrice: 'Supply Price',
    supplyPriceExplain: 'Full-service contract signing price',
    platformPriceExplain: 'Our platform selling price suggested by sellers',
    imageUploadSpecifications: 'Image Upload Specifications',
    basicRequirements: 'Basic Requirements',
    fileSize: 'File Size: Single file ≤ 10MB (use compression tools for oversized files)',
    aspectRatio: 'Aspect Ratio: 1:1 (±10% tolerance; e.g., 800×800px accepts 720×800 to 800×880)',
    fileCount: 'Quantity Limit: Maximum 5 files',
    formatExamples: 'Format & Examples',
    supportedFormats: 'Supported Formats: JPG/PNG/GIF (recommend compressing before upload)',
    sampleDimensions: 'Sample Dimensions: 800×800px (proportional variations like 720×800 or 800×880 are acceptable)',
    tips: 'Tips',
    tips1: 'Images with inconsistent ratios may be distorted—please crop in advance.',
    tips2: 'For file size issues, please use a compression tool to resize.',
    selectCategoryTip: 'Please select the most specific category level',
    spuExistsTip: 'SPU already exists. Please modify it.',
    draftId: 'Draft ID',
    noOption: 'No suitable option? ',
    createType: 'Create Specification Item',
    inputType: 'Select Specification Item',
    typeEg: 'Eg:Color',
    createValue: 'Create Specification Value',
    inputValue: 'Input Specification Value',
    valueEg: 'Eg:Red',
    documentProofs: 'Document Proofs',
    customsDeclaration: 'Customs Declaration',
    purchaseInvoice: 'Purchase Invoice',
    warehouseEntryVoucher: 'Warehouse Receipt',
    certificateOfGoods: 'Entrusted Goods Proof',
    brandAuthorizationLetter: 'Brand Authorization',
    documentProofsTip: 'Sellers must provide at least one of the above documents as proof. Maximum 5 files per type, single file ≤ 10M',
    tradeLegalityDesc: 'Imported goods (must include product code, customs clearance date, seller name, tax payment status, etc.)',
    originAuthenticityDesc: 'Purchased goods (must include VAT number, purchaser and seller must be consistent)',
    inventoryExistenceDesc: 'Third-party overseas warehouse managed goods (must show outbound time, SKU code, seller name)',
    goodsAuthenticityDesc: "Issuing warehouse's official contact information, certificate number, goods details",
    ipComplianceDesc: "Agent/distributed brand goods (requires brand owner's seal and authorization validity period)",
    productHome1: 'Bulk add existing product information to my store',
    productHome2: 'Click button - Download template - Fill in information - Upload file - One-click batch add',
    productHome3: 'Quickly add existing platform products to my store',
    productHome4: 'Click to search products - Select products - Customize attributes - Confirm addition',
    productHome5: 'Create brand new products for my store',
    productHome6: 'Click to create manually - Complete product information - Customize settings - Confirm creation',
    productHome7: 'To better enjoy HURIX\'s sales promotions, please publish your products as soon as possible.',
    productHome8: 'Sync Products from Authorized Stores to HURIX',
    productHome9: 'Sync product information from authorized third-party stores to HURIX ',
    noProducts: 'No related products yet. ',
    createANewProduct: 'Create a new product',
    authorizedStore: 'Authorized Store',
    rulesCenter: 'Rules Center',
    priceAndStock: 'Price & Stock',
    uploaded: 'Uploaded ',
    introTip: 'Drag & drop supported. Recommended: 620-1290px width, < 2000px height. Oversized images will be auto-cropped. Max 5MB, JPG/JPEG/PNG only.',
    linkOtherWarehouse: 'Add Other Warehouse',
    noWarehouseFound: 'No warehouse found?',
    selling: "Live",
    soldOut: "Sold Out",
    searchPlaceholder: 'Enter product name / product ID / seller SPU / seller SKU, multiple items separated by commas',
    searchPlaceholderDraft: 'Enter product name / draft ID / seller SPU, multiple items separated by commas',
    publishSimilar: 'Publish Similar Product',
    priceMustBeLower: 'Total (price + VAT) must be below reference price',
    applyForEntry: 'Apply for Entry',
    importRecords: 'Import Records',
    fileName: 'File Name',
    uploadTime: 'Upload Time',
    uploading: 'Parsing',
    parsingSuccessful: 'Parsing successful',
    parsingFailed: 'Parsing failed',
    viewTaskList: 'View Task List',
    confirmDeleteDraft: 'Confirm delete draft?',
    sureToDeleteDraft: 'Are you sure you want to delete the draft? The draft cannot be recovered once deleted.',
    confirmPutOnSale: 'Confirm to put this product on sale? ',
    confirmTakeOffline: 'Confirm to take this product offline? ',
    takeOfflineTip: 'Once delisted, the product will no longer be available for sale.',
    publishSimilarTip: 'Avoid creating duplicate listings when publishing similar products, as having multiple identical items can harm the shopping experience and reduce sales.',
    profitable: 'Profit',
    imageNotFound: 'Image element not found',
    invalidCropArea: 'Please select a valid crop area',
    abnormalImageSize: 'Abnormal image dimensions',
    cropAreaOutOfBounds: 'Crop area is outside the image boundaries',
    browserNotSupported: 'Browser does not support cropping function',
    imageSizeExceeded: 'Image still exceeds 10M after compression, please try a smaller crop area',
    products: 'items',
    TotalProductPrice: 'Item Total',
    taxes: 'taxes',
    total: 'total',
    productVat: "VAT on Product",
    shippingVat: "VAT on Shipping",
  },
  order: {
    MyOrder: 'Manage orders',
    order: 'Order',
    orderNumber: 'Order Number',
    buyer: 'Buyer',
    orderTime: 'Order Date',
    orderStatus: 'Order Status',
    startDate: 'Start Date',
    endDate: 'End Date',
    orderAmount: 'Order Amount',
    paymentMethod: 'Payment Method',
    viewOrder: 'View Order',
    PendingPayment: 'Awaiting Payment',
    toBeConfirmed: 'To be confirmed',
    pendingShipment: 'Ready to Ship',
    partialShipment: 'Partially Shipped',
    inTransit: 'In Transit',
    completed: 'Completed',
    OrderCompleted: 'Completed',
    closed: 'Closed',
    OrderClosed: 'Closed',
    Cancelled: 'Cancelled',
    alipay: 'Alipay',
    wechat: 'WeChat',
    unpaid: 'unpaid',
    BuyerPlacesOrder: 'Buyer Places Order',
    PaymentSuccessful: 'Payment Successful',
    MerchantShipsGoods: 'Merchant Ships Goods',
    TransactionCompleted: 'Transaction Completed',
    modifyRecipientInformation: 'Modify Recipient Information',
    orderLog: 'Order History',
    separatePackageDelivery: 'Separate Package Delivery',
    ShipOrder: 'Ship Order',
    noUnshippedItems: 'There are no unshipped items. Please check your orders.',
    orderStatusTip: "Order status updated, please refresh your browser",
    cancellationOfOrder: 'Cancellation of Order',
    addANote: 'Add a Note',
    logisticsInformation: 'Logistics Information',
    InsuranceInformation: 'Insurance Information',
    LogisticsUpdates: 'Logistics Updates',
    orderDetails: 'Order Details',
    receiptInformation: 'Deliver to',
    buyerMessage: 'Buyer Message',
    orderNotes: 'Order Notes',
    invoiceInformation: 'Invoice Information',
    noInvoiceInformation: 'Invoice details not provided',
    specifications: 'Specifications',
    number: 'Quantity',
    subtotal: 'Subtotal',
    totalAmount: 'Item Total',
    payableAmount: 'Payable Amount',
    FullName: 'Full name',
    recipientRegion: 'Recipient Region',
    detailedAddress: 'Detailed Address',
    shippingAddress: 'Shipping Address',
    ShippingInformation: 'Shipping Information',
    DeliveryInformation: 'Delivery Information',
    DeliveryMethod: 'Delivery Method',
    LogisticsDelivery: 'Logistics Delivery',
    OtherInformation: 'Other Information',
    PurchaseSource: 'Purchase Source',
    WebVersion: 'Web Version',
    postcode: 'Postcode',
    logisticsCompany: 'Carrier',
    logisticsStatus: "Logistics Status",
    trackingNumber: 'Shipment Number',
    deliveryTime: 'Delivery Time',
    shipmentQuantity: 'Shipment Quantity',
    noLogisticsInformation: 'No Logistics Information',
    orderType: 'Order Type',
    realtimeOrder: 'Realtime Order',
    purchaseRequest: 'Purchase Request',
    platformHandlingFee: 'Platform Commission Fee',
    settlementHandlingFee: 'Settlement Handling Fee',
    CardPaymentHandlingFee: 'Payment Handling Fee',
    refundFee: 'Refund Processing Fee',
    refundFeeRule: 'A fixed processing fee of num will be charged per refund transaction.',
    revenueAmount: 'Revenue Amount',
    ReservationInformation: 'Pre-order Information',
    ReservationPeriod: 'Pre-order Period',
    priceModel: 'Price Model',
    NumberOfReservations: 'Pre-order Quantity',
    dividedParcelDelivery: 'Divided Parcel Delivery',
    LogisticsTrackingNumber: 'Logistics Tracking Number',
    unitPrice: 'Unit Price',
    ParcelSent: 'Parcel Sent',
    SurplusCommodity: 'Surplus Commodity',
    subtotalOf: 'Subtotal Of',
    selectLogisticsCompany: 'Please select carrier',
    fillLogisticsTime: 'Please fill in the delivery time',
    fillTrackingNumber: 'Please fill in the tracking number',
    selectItemShip: 'Please select at least one item to ship',
    PleaseShipAtLeastOneItem: 'Please ship at least one item',
    whetherModifyReceivingInformation: 'Whether to modify the receiving information',
    sureWantCancelOrder: 'Are you sure you want to cancel the order?',
    WantChangeRemarksOrder: 'Are you sure you want to change the remarks order?',
    RealTimeOrder: 'Real-Time Orders',
    ReservationOrder: 'Pre-Orders',
    lockPriceModel: 'Lock Price Model',
    noLockPriceModel: 'No Lock Price Model',
    days: 'Days',
    PromiseShip: 'Confirm shipment in',
    PromiseShip2: '',  // 有用别删
    autoCancelTip: "The order will be automatically cancelled in ",
    autoCancelTip2: ". Please arrange shipment promptly.",
    ReservationInProgress: 'Pre-Order in Progress',
    PreOrderInProgress: 'Pre-Orders in Progress',
    proportionOfDeposit: 'Deposit Percentage',
    amountOfDeduction: 'Amount of deduction',
    deposit: 'deposit',
    AwaitingReceipt: 'Out for Delivery',
    waitBuyerShip: "Awaiting Buyer Shipment",
    waitSellerReceive: "Awaiting Seller Receipt",
    ReservationCompleted: 'Pre-order Completed',
    PreOrderCompleted: 'Pre-Orders Completed',
    batchShipment: 'Bulk Dispatch',
    RemainingReservableQuantity: 'Remaining Pre-orderable Quantity',
    ReservationOrderNo: 'Pre-order Number',
    PolicyNumber: 'Policy Number',
    InsuranceCompany: 'Insurance Company',
    PolicyStatus: 'Policy Status',
    AmountInsurance: 'Insurance Premium Amount',
    AmountCompensation: 'Compensation Amount',
    InEffect: 'In Effect',
    failure: 'lose efficacy',
    undo: 'Undo',
    ClaimsProgress: 'Claims In Progress',
    CompensationComplete: 'Compensation Completed',
    Terminate: 'Terminated',
    Frozen: 'Frozen',
    state: 'State/Province',
    downloadBatchShippingTemplate: 'Download Bulk Dispatch Template',
    batchShippingTemplate: 'Bulk Dispatch Template',
    noOrder: 'You do not have any orders that need to be shipped',
    country: 'Country/Region',
    city: 'Town/City',
    enterCorrectEmail: 'Please enter the correct email address',
    InRefund: 'In Refund',
    RefundSuspension: 'Refund Suspended',
    RefundSuccessful: 'Refund Succeeded',
    RefundFailure: 'Refund Failed',
    InRefundLog: 'Your refund is being processed.Please wait patiently',
    RefundSuspensionLog: 'Refund suspended due to insufficient account balance',
    RefundCompletedLog: 'Your refund has been processed successfully',
    RefundFailureLog: 'Your refund request has failed',
    insufficientStockReservation: 'Your pre-order has been canceled and a refund will be issued due to insufficient stock of the item',
    refund: 'Refund',
    created: 'Created',
    enterReasonRefund: 'Please enter the refund reason',
    createdLog: 'Order has been created',
    toBeConfirmedLog: 'Your order has been submitted.We‘re now processing it - please wait a moment',
    PendingPaymentLog: 'Order Confirmed, Awaiting Buyer\'s Payment',
    pendingShipmentLog: 'Buyer Has Paid, Please Ship Soon!',
    partialShipmentLog: 'Partial products have been shipped – Don\'t forget to send out the remaining products!',
    InTransitLog: 'All products have been fully dispatched, In Transit',
    WaitToBeReceivedLog: 'Products have arrived at the destination, Awaiting Buyer\'s Receipt',
    completedLog: 'Order Completed, Thank you for your cooperation',
    ReservationInProgressLog: 'Pre-Order In Progress(Awaiting Fulfillment)',
    ReservationCompletedLog: 'All pre-ordered products have been purchased, and the pre-order is now closed',
    closedLog: 'Payment timeout, the system cancels the order',
    CancelledLog: 'Order has been cancelled',
    RefundLog: 'Refund History',
    RefundAmount: 'Refund Amount',
    RefundStatus: 'Refund Status',
    BuyerPaid: 'Paid by Buyer',
    PlatformCommission: 'Platform Commission',
    PaidInAmount: 'Paid-In Amount',
    commodityInformation: 'Product Information',
    NumberOfPurchaseRequests: 'Number of purchase requests initiated',
    InitiatePurchase: 'Initiate Purchase',
    cancelPurchase: 'Cancel Purchase',
    CommodityQuantity: 'Approved Products',
    completeTime: 'Order Completion Date',
    level: 'Level',
    returnReview: 'Return Review',
    returnInfo: 'Return Information',
    auditOperation: 'Audit Operation',
    returnAndRefunds: 'Returns & Refunds',
    fillDeliveryAddress: 'Fill in Delivery Address',
    fillInReturnAddress: 'Fill in the return address',
    defaultReturnWarehouseAddress: 'The default address is the warehouse address for returned products',
    pleaseFillDeliveryAddress: 'Please Fill in Delivery Address',
    returnAddress: 'Return Address',
    ReturnRequestNo: 'Return Request #',
    ReturnLog: 'Return History',
    createdReturn: 'New return request received',
    toBeConfirmedReturn: 'Please process the return request promptly',
    pendingShipmentReturn: 'Return confirmed - awaiting buyer shipment',
    inTransitReturn: 'Returned items have been shipped and are in transit',
    AwaitingReceiptReturn: 'Returned items have arrived - please collect promptly',
    completedReturn: 'Return process completed - refund initiated',
    reviewRejectedReturn: 'Return request closed (seller declined)',
    CancelledReturn: 'The return application has been cancelled and the return process is closed',
    confirmReceipt: 'Confirm Receipt',
    confirmReceivedGoods: 'Please confirm that you have received the goods',
    returnList: 'Return List',
    returnInformation: 'Return Information',
    returnStatus: 'Return Status',
    returnTime: 'Return Time',
    pendingReturnsReview: 'Pending return require your review',
    platformInterventionInProgress: 'Platform intervention underway',
    returnReason: 'Return Reason',
    returnVerificationPhotos: 'Return Verification Photos',
    Returned: 'Return Exists',
    returnDetails: 'Return Details',
    breachQuantity: 'Breach Quantity',
    purchasableQuantity: 'Purchasable Quantity',
    refundDetails: 'Refund Details',
    refundReason: 'Refund Reason',
    refundTransaction: 'Refund Transaction ID',
    RefundsReturns: 'Return & Refund',
    returnOccurs: 'Return',
    refundHappens: 'Refund',
    None: 'None',
    purchasableQuantityReduce: 'Insufficient product inventory. Purchasable quantity has been reduced by refundQuantity',
    releaseQuantityRefunded: 'Refund due to insufficient product inventory',
    returnRecords: 'Return Records',
    refundRecords: 'Refund Records',
    ReturnId: 'Return Number',
    credential: 'Credential',
    afterConfirmingReceipt: 'The corresponding payment will be refunded to the buyer after confirming receipt.',
    negotiationHistory: 'Negotiation History',
    ReturnRequestSubmitted: 'A return request has been submitted, awaiting the seller\'s processing',
    ReturnRequestApproved: 'Return Request Approved',
    buyerHasShipped: 'The buyer has shipped the goods',
    ReceiptConfirmedSeller: 'Receipt Confirmed by Seller',
    ReturnRequestRejected: 'Return Request Rejected',
    ReturnRequestCancelled: 'Return Request Cancelled',
    notes: 'Notes',
    RefundType: 'Refund Type',
    RequestPlatformIntervention: 'Request platform intervention',
    PlatformIntervention: 'Platform Intervention',
    PlatformProcessing: 'Platform Processing',
    PlatformAdjustsReturnStatus: 'Platform Adjusts Return Status',
    credentialIsBasis: 'The credential is a crucial basis for the platform when resolving disputes.',
    senderAddress: 'Sender Address',
    importantNoticeStrictlyShip: 'Important Notice: Strictly ship via the buyer\'s designated logistics provider. Available carriers may vary by product category — please verify carefully before dispatch.',
    selectedShippingCarrier: 'Carrier selected for this order:',
    SuccessfullyDeleted: 'Successfully Deleted',
    CreditCard: 'Credit Card',
    Review: 'Review',
    CancellationTime: 'Cancellation Time',
    CancellationReason: 'Cancellation Reason',
    OrderCancellationDetails: 'Order Cancellation Details',
    CancellationLog: 'Cancel Order History',
    RequestTime: 'Requested Time',
    cancelHasBeenInitiated: 'A cancellation request for the order has been initiated',
    ReviewStatus: 'Review Status',
    pendingApproval: 'Pending Approval',
    pendingSubmission: 'Pending Submission',
    pleaseReviewCancel: 'The buyer has initiated an order cancellation request',
    PendingCancellationReview: 'Pending cancellation requests require your review',
    cancelAuditReminder: 'You have unreviewed cancellation requests',
    RefundOnly: 'Refund only',
    PartyLiableShipment: 'Party liable for shipping rate (shipment)',
    PartyLiableReturn: 'Party liable for shipping rate (return)',
    shipmentTotalMoney: 'Total shipping rate (shipment)',
    returnTotalMoney: 'Total shipping rate (return)',
    TotalRefundAmount: 'Total refund amount',
    estimated: 'Estimated',
    ReturnLogisticsCompany: 'Return Carrier',
    all: 'All',
    AllOrders: 'All Orders',
    requiredToShip: '24h required to ship',
    OvertimeShipped: 'Overtime not shipped',
    ExportOrder: 'Export Order',
    LastDay: 'Last 24 hours',
    LastDay7: 'Last 7 days',
    LastDay30: 'Last 30 days',
    LastDay90: 'Last 90 days',
    AfterSalesStatus: 'After-sales Status',
    Balance: 'Balance',
    BuyerInformation: 'Buyer Information',
    BuyerRemarks: 'Buyer Remarks',
    BuyerNickname: 'Buyer Nickname',
    price: 'Price',
    paymentTime: 'payment time',
    OrderTotal: 'Order Total',
    orderTotalSubVat: 'Net order amount',
    ReservationDeductionAmount: 'Pre-order Deduction',
    ShipFree: 'Free Delivery',
    returnLabelGenerationSellerNote: 'After approving the return request, the system will automatically generate a courier waybill. This process may fail – please re-review the return if it does.',
    labelGenerationStatus: 'Courier waybill status',
    labelGeneratedSuccess: 'Generated successfully',
    labelGenerating: 'Generating',
    labelGeneratedFailed: 'Generation failed',
    GeneratingLabel: 'Return waybill is being generated',
    returnShippingLabelGenerating: 'Return courier waybill is being generated',
    consigneeEmailOrPhone: 'Consignee Phone / Email',
    afterSaleRecordsTip: 'num after-sales records , Click to view',
    hours: 'hours',
    minutes: 'minutes',
    orderCreatedTime: 'Order Created Time',
    platformSelfOperated: "Platform Self-operated",
    refundOnlyTip: "Refund-only orders support adjustment of the refund amount. It is recommended that you check carefully before modification to reduce unnecessary disputes.",
  },
  logistics: {
    shippingCost: 'Shipping & handling',
    deliveryType: 'Delivery Type',
    standardSingleParcel: 'Standard Single Parcel',
    expressSingleParcel: 'Express Single Parcel',
    multipleParcels: 'Multiple Parcels',
    weightLimit: 'Weight Limit',
    perParcel: 'Per Parcel',
    transitTime: 'Transit Time',
    businessDays: 'Business Days',
    BaseShippingCost: 'Base Freight',
    Surcharge: 'Surcharge',
    SeparateRates: 'Separate Rates',
    remoteAreas: 'Remote areas +',
    remoteArea: 'Remote areas',
    MultiParcelFee: 'Multi-Parcel Handling Fee',
    chargeableWeight: 'Chargeable Weight',
    AddressLine1: 'Address Line 1 (or Company Name)',
    AddressLine2: 'Address Line 2',
    AddressLine: 'Address Line 1',
    Recipient: 'Recipient',
    addAddress: 'Add Address',
    SureDeleteShippingAddress: 'Are you sure you want to delete this shipping address?',
    shippingBillingRules: 'Shipping billing rules',
    remoteAreaNoFreeShipping: 'No free shipping to remote areas',
    billingWeightComparisonTable: 'Billing weight comparison table',
    billingWeightComparisonTableRemoteArea: 'Billing weight comparison table (remote areas)',
    isRemoteArea: 'Remote area?',
    yesOption: 'Yes',
    noOption: 'No',
    UKMainland: 'UK mainland',
    modifyLogisticsInfo: 'Modify logistics information',
    fillInModifiedInfo: 'Please fill in the modified information',
    UnitedKingdom: 'United Kingdom',
    yodelServiceCentreAndLocalAreas: 'Yodel ServiceCentre & local areas',
    postcodeDistrict: 'Postcode district',
    standardRate: "Standard Rate",
    ladderBilling: "Tiered Billing",
    currentBilling: "Current Charge",
    estimatedDeliveryText: "Estimated delivery in 3-7 working days",
    earliestShipTip: "Expected to ship before 24:00 at the earliest",
  },
  settings: {
    manualShipment: 'Manual shipment or bulk shipment via Excel',
    autoPushOrder: 'Orders will be automatically pushed to this system',
    primaryClassification: 'Primary Classification',
    addSubcategory: 'Add Subcategory',
    expand: 'Expand Categories',
    collapse: 'Collapse Categories',
    parameter: 'Parameter',
    optionalValues: 'Optional Values',
    parameterGroup: 'Parameter Group',
    noParameter: 'No parameter binding information available at the moment',
    warehouseCode: 'Warehouse Code',
    warehouseName: 'Warehouse Name',
    enterWarehouseName: 'Please enter goods warehouse name',
    warehouse: 'Warehouse',
    address: 'Address',
    countryCode: 'Country/Region',
    email: 'Email',
    addWarehouse: 'Add Warehouse',
    pleaseContactCustomer: 'Please contact customer',
    editWarehouse: 'Edit Warehouse',
    warehouseLoading: 'Warehouse loading...',
    warehouseEmail: 'Warehouse Email',
    warehouseSystem: 'Warehouse System',
    clickToViewAppKeyAndAppSecret: 'Click to view how to get AppKey and AppSecret',
    pleaseEnterAppKey: 'Please enter AppKey',
    pleaseEnterAppSecret: 'Please enter AppSecret',
    warehouseCodeLabel: 'Warehouse Code',
    needToFillAppKeyAndAppSecretFirst: 'Please fill in AppKey and AppSecret first',
    postCode: 'Post Code',
    deliveryInfo: 'Shipping Setting',
    weightRange: 'Weight range',
    britishMainland: 'UK Mainland',
    newRule: 'New Rule',
    andAbove: 'And Above',
    cost: 'Cost excluding VAT',
    minWeight: 'Min weight',
    oneRuleRequired: 'At least one rule is required.',
    abovePreviousMaximum: 'Above previous maximum ',
    consigneeName: 'Consignee/Shipper Name',
    consigneeSurname: 'Consignee/Shipper Surname',
    consigneeEmail: 'Consignee/Shipper Email',
    consigneeInformation: 'Consignee/Shipper Information',
    updateConsignee: 'Repository Settings'
  },
  menu: {
    myShelves: 'My Shelves',
    dashboard: 'Dashboard',
    brandAudit: 'Brand Audit',
    addProduct: 'Add New Product',
    editProduct: 'Edit Product',
    permission: 'Permission',
    warehouseList: 'Warehouse List',
    userList: 'Operator List',
    roleList: 'Role List',
    product: 'Product',
    productTemplate: 'Drafts ',
    productRelease: 'Product Release',
    productList: 'Product List',
    productDetails: 'Product Details',
    platformVerify: 'Platform Verify',
    platformProducts: 'Platform Products',
    productSort: 'Product Sort',
    brandManagement: 'Brand',
    addBrand: 'Add Brand',
    editBrand: 'Edit Brand',
    unitOfMeasurement: 'Unit Management',
    platformRole: 'Platform Role',
    menuList: 'Menu List',
    resourceList: 'Resource List',
    platformUsers: 'Platform Users',
    mallUsers: 'Mall Users',
    shop: 'Goods Shelves',
    operator: 'Account',
    myShop: 'My Shop',
    order: 'Order',
    myOrder: 'Manage orders',
    platformOrders: 'Platform Orders',
    orderList: 'Order List',
    settings: 'Settings',
    warehouseAudit: 'Warehouse Audit',
    myWarehouse: 'My Warehouse',
    myProducts: 'My Products',
    ShippingList: 'Shipping List',
    returnApplicationProcessing: 'Return Application Processing',
    returnReasonSetting: 'Return Reason Setting',
    ReturnReasonDetails: 'Return Reason Details',
    Marketing: 'Marketing',
    SecondKillActivityList: 'Seckill Activity List',
    SecondsKillTimeList: 'Seckill Time Range List',
    SecondsKillTimeSelection: 'Seckill Time Selection',
    SeckillProductList: 'Seckill Product List',
    CouponList: 'Coupon List',
    AddCoupons: 'Add Coupons',
    ModifyCoupon: 'Modify Coupon',
    CouponCollectionDetails: 'Coupon Collection Details',
    BrandRecommendation: 'Brand Recommendation',
    NewProductRecommendation: 'New Product Recommendation',
    PopularRecommendation: 'Popular Recommendation',
    SpecialTopicRecommendation: 'Special Topic Recommendation',
    AdvertisingList: 'Advertising List',
    AddAds: 'Add Ads',
    EditorialAdvertising: 'EditorialAdvertising',
    orderAuditList: 'Manage Returns',
    settlementList: 'Settlement List',
    settleDetails: 'Settlement Details',
    AfterSalesDetails: 'After-sales Details',
    AfterSalesService: 'After-sales Service',
    fund: 'Fund',
    accountCenter: 'Account Center',
    billManagement: 'Bill Management',
    finance: 'Finance',
  },
  tableColumns: {
    operator: 'Operator',
    time: 'Time',
    previousStatus: 'Previous Status',
    currentState: 'Current State',
    creditValueBeforeChange: 'Credit Value Before Change',
    currentCreditValue: 'Current Credit Value',
  },
  im: {
    searchForContacts: 'Search for contacts',
    ChatLog: 'Chat Log',
    send: 'Send',
    wouldLikeTalk: 'What would you like to talk about...',
    noMore: 'There is no more',
    imageFormat: 'The image format does not meet the requirements. Only jpg, jpeg, png types are supported',
    withdraw: 'Withdraw',
    ShelfMessage: 'Message',
    PlatformAdministrator: 'Platform Administrator',
    allMessages: 'All Messages',
    productReviewRejected: 'Product Review Rejected',
    productReviewApproved: 'Product Review Approved',
    productExpirationReminder: 'Product Expiration Reminder',
    customerService: 'Support',
    reachedHurixCustomer: 'Good day, you\'ve reached the HURIX Customer Support Team. How may we assist you today?',
    frequentlyAskedQuestions: 'Frequently Asked Questions',
    refundReturnPolicy: 'Refund and Return Policy',
    messageNotifications: 'Notifications',
    noNotifications: 'No Notifications',
    connectionStatus: 'Connection Disconnected',
    csConnectionError: 'Your connection to customer service has been interrupted. Please try reconnecting or select an alternative contact method.',
    reconnectAction: 'Reconnect',
    alternativeContactMethod: 'Other Contact Options',
    ScanQRcodeTip: 'Follow our WeChat Account to consult online',
  },
  shelves: {
    shelfInformation: 'Shelf Information',
    shelfLogo: 'Logo',
    shelfDescription: 'Shelf Description',
    companyInformation: 'Company Information',
    companyName: 'Company Name',
    contacts: 'Contacts',
    registrationNo: 'Company Registration No.',
    assigningRoles: 'Assign Roles',
    pleaseSelectARole: 'Please Select A Role',
    RegistrationNotice: 'Registration Notice',
    registrationRequirementsNotice: `Please ensure that you fully acknowledge and comply with the following essential registration requirements and guidelines. Verify each item individually before submitting your application:`,
    authenticityInformation: 'Authenticity of the submitted information and supporting documents.',
    ProductsComplyStandards: `Compliance with national quality standards and no infringement of others' intellectual property rights.`,
    additionalInformationOrDocumentation: `HURIX reserves the right to conduct random inspections on merchants' information and supporting documents to verify their authenticity and legality.`,
    hadReadService: 'I have read and agree to the',
    serviceTerms: 'HURIX Seller Self‑Operated Service Agreement',
    successfullySettledIn: 'Your application has been submitted, please be patient and wait.',
    sendEmailResult: 'We will inform you of the result via email.',
    CompanyName: 'Company Name',
    RegistrationNo: 'Registration No.',
    Contact: 'Contact',
    fillFirstName: 'Please fill in the first name',
    fillLastName: 'Please fill in the last name',
    EmailVerificationCode: 'Email Verification Code',
    successfulSubmission: 'Successful submission!',
    EmailIncorrect: 'The email verification code is incorrect. Please re-enter after getting a new one',
    SMSIncorrect: 'The SMS code is incorrect. Please re-enter after getting a new one',
    NoAccountRegister: 'No account yet ? Register',
  },
  noPage: {
    pageLost: 'Sorry, the page got lost accidentally ',
    checkPage: 'Please check if the URL you entered is correct. Click the following button to return to the homepage or send an error report. ',
    goHome: 'Homepage'
  },
  logOff: {
    title: 'Cancel Account',
    warning: 'Important Notice',
    warningTips: 'Account cancellation is an irreversible operation. Once submitted, your account and all related data will be permanently deleted. Please confirm the following before proceeding:',
    allProductDelist: 'Please ensure all products in your store have been delisted',
    ensureOrderComplete: 'Please ensure all orders have been processed',
    allDataDelete: 'All store data will be permanently deleted',
    allInfoDelete: 'All associated store information cannot be recovered',
    verifyEmail: 'Verify Email',
    enterEmail: 'Enter your registered email',
    confirmCancel: 'Confirm Cancellation',
    cancelAccountCancellation: 'Cancel Cancellation',
    cancelStatus: 'Cancellation Status',
    successTitle: "Account cancelled successfully",
    verificationSent: "Verification code sent to your email",
    stepMessages1: 'Verifying email information...',
    stepMessages2: 'Checking product delist status...',
    stepMessages3: 'Verifying order status...',
    stepMessages4: 'Verifying billing information...',
    stepMessages5: 'Verifying debt status...',
    stepMessages6: 'Verifying wallet balance...',
    stepMessages7: 'Please confirm account cancellation...',
    confirmCancellation: 'Confirm Cancellation',
    successMessages1: 'Email verification completed',
    successMessages2: 'Product delist check passed',
    successMessages3: 'Order status check passed',
    successMessages4: 'Bill settlement check passed',
    successMessages5: 'Debt check passed',
    successMessages6: 'Wallet balance check passed',
    successMessages7: 'Account cancelled successfully',
    passwordPlaceholder: "Enter your account password",
    progressTitle: 'Account Cancellation in Progress...',
    steps1: 'Verification',
    steps2: 'Delist Products',
    steps3: 'Order Check',
    steps4: 'Check Unsettled Orders',
    steps5: 'Check Debts',
    steps6: 'Check Wallet Balance',
    steps7: 'Password Confirmation',
    cancelConfirm: 'Are you sure you want to cancel the process',
    emailVerityFailed: 'Email verification code check failed',
    productsNotDown: 'Product delist check failed. Please delist all products first.',
    pendingOrderError: 'Order status check failed. Please process all pending orders first.',

    autoTakeDown: 'Delist Now',
    manualTakeDown: 'Delist Manually',
    allProductsDown: 'All products have been successfully delisted',
    goProcessOrders: 'Go Process Orders',
    goSettleOrders: 'Go View Bills',
    goRepayDebt: 'Repay Now',
    goWithdraw: 'Go Withdraw',
    unsettledOrderError: 'Bill settlement check failed. Please wait for all orders to be settled.',
    debtError: 'Your account has outstanding arrears and cannot be operated temporarily. Please settle all arrears first.',
    walletBalanceError: 'Wallet balance check failed. Please withdraw all balance first.',

    cancelFailed: 'Cancellation failed',
    checkUnsettledOrdersFailed: 'Check unsettled orders failed',
    checkDebtFailed: 'Check debt failed',
    checkWalletBalanceFailed: 'Check wallet balance failed',
    consequence1: 'All products in the store will be delisted',
    consequence2: 'All orders in the store will be invalidated',
    consequence3: 'All bills in the store will be invalidated',
    consequence4: 'All store data will be permanently deleted',
    consequence5: 'All associated store information cannot be recovered',
  },
  register: {
    TwoStepVerification: 'MFA Multi-Factor Authentication',
    AddValidatorApplication: 'Add Validator Application',
    Validator: 'Validator',
    authenticatorApp: 'Authenticator app',
    generatePasswordsConnection: 'Use the app to generate one-time password without needing an internet connection.',
    enterGeneratedPassword: 'You will enter the generated one-time password when logging in, in the same way you would use a one-time password received via SMS.',
    OpenYourAuthenticatorApp: 'Open your authenticator app.',
    NeedAuthenticatorApp: 'Need an authenticator app?',
    AddAccountScanQR: 'Add an account in the app, then scan the QR code below.',
    enterThePassword: 'Enter the one-time password.',
    qrCodeConfirmGuide: 'After scanning the QR code, click the Confirm button below.',
    AfterScanningQR: 'After scanning the QR code, enter the one-time password generated by the app:',
    VerifyAndContinue: 'Verify the one-time password and continue',
    IncorrectPassword: 'Incorrect password. If this error persists, please rescan the QR code.',
    DownloadAuthenticatorApp: 'Download the Authenticator app',
    HowToDownload: 'How to download:',
    yourAppStore: 'Go to your phone\'s app store.',
    SearchAuthenticatorApp: 'Search for "Authenticator app".',
    DownloadApp: 'Download the app.',
    GoogleAuthenticator: 'E.g. , AWS Virtual MFA, Google Authenticator, Microsoft Authenticator',
    hasBeenAddedSuccessfully: 'The validator application has been added successfully',
    ValidatorApp: 'Validator App',
    whetherDeleteAuthenticator: 'Confirm whether to delete this authenticator',
    enterPasswordReceivedNumber: 'Please enter the one-time password received by the phone number ending with [phoneNum]:',
    enterAuthenticatorGenerated: 'Please enter the one-time password generated by the authenticator app:',
    verificationFailed: 'Verification code verification failed. Please get a new one and enter it again',
    authenticatorBeforeUsing: 'Please go to [My Account] > [Two-Step Verification] to add an authenticator app before using',
    identityWithEmail: 'For account security, please verify your identity with the email: 【emailNum】',
    identityInputEmail: 'please verify your identity with the email: 【emailNum】',
    NoEmailFound: 'No user email found',
    Attachment: 'Attachment',
    receivedAtEmail: 'Please enter the one-time password received at 【emailNum】',
    UseAnotherAuthenticator: 'Use another authenticator',
    selectObtainVerification: 'Please select a way to obtain the verification code',
    enterPasswordGenerated: 'Please enter the one-time password generated by 【AuthenticatorName】',
    AuthenticatorAppName: 'Authenticator app name',
    enterAuthenticatorAppName: 'Please enter the name of your authenticator app',
    SetDefault: 'Set as default',
    DefaultAuthenticator: 'Default Authenticator',
    ConfirmSettingDefault: 'Confirm setting as default validator?',
    PleaseSetAnother: 'Please set another authenticator as the default authenticator first',
    RegisterAsSeller: 'Register as a Seller',
    ShipperInformation: 'Seller Information',
    username: 'Username',
    nickName: 'Nickname',
    phoneNumber: 'Phone number',
    phoneVerificationCode: 'Phone Verification Code',
    phoneNumberRegistered: 'This phone number is already registered',
    IdentityVerification: 'Identity Verification',
    selectIdentityVerification: 'Please select the method of identity verification',
    enterNewMobile: 'Please enter your new mobile phone number',
    enterNewEmail: 'Please enter your new email address',
    UpdatePhoneNumber: 'Update mobile phone number',
    UpdateEmail: 'Update email address',
    samePhoneNumber: 'The new mobile phone number is the same as the currently bound number. Please use another mobile phone number',
    sameEmail: 'The new email address is consistent with the currently bound email. Please use another email address.',
    validatorAppLimitTip: 'The system only supports adding one validator app. You can delete the existing added app first, then add a new validator app.',
    firstName: 'First name',
    lastName: 'Last name',
    Privacy: 'Privacy',
    Clause: 'Terms',
    PoweredBy: 'Powered by',
    PoweredBy2: '',  // 不要删
  },
  settlement: {
    ReservationOrderNo: 'Pre-order Number', // 变量名建议小驼峰
    payAmount: 'Amount Payable',
    deductionType: 'Deduction Type',
    status: 'Settlement Status',
    time: 'Settlement Time',
    settlement: 'Settlement',
    pendingSettlement: 'Pending Settlement',
    delayedSettlement: 'Delayed Settlement',
    isDelay: 'Is Delay',
    normal: 'Normal',
    settled: 'Settled',
    payAmountDue: 'Pay Amount Due',
    settlementFailed: 'Settlement Failed',
    confirm: 'Are you sure you want to settle the current order?',
    tradingTime: 'Trading Time',
    platformTransactionId: 'Platform Transaction ID',
    reconciliation: 'Reconciliation',
    reconciliationStatus: 'Reconciliation Status',
    myMoneyTransactionId: 'MyMoney Transaction ID',
    transactionAmount: 'Platform Transaction Amount(£)',
    myMoneyFee: 'MyMoney Fee(£)',
    myMoneyTax: 'MyMoney Tax(£)',
    platformReceivedAmount: 'Platform Received Amount(£)',
    transactionType: 'Transaction Type',
    reconciliationResult: 'Reconciliation Result',
    discrepancyType: 'Discrepancy Type',
    reconciliationTime: 'Reconciliation Time',
    adjustmentAmount: 'Adjustment Amount(£)',
    adjustmentRemark: 'Adjustment Remark',
    estimatedAdjustment: 'Estimated Adjustment',
    uploadReconciliationFile: 'Upload Reconciliation File',
    unreconciled: 'Unreconciled',
    reconciling: 'Reconciling',
    completed: 'Completed',
    balanced: 'Balanced',
    imbalanced: 'Imbalanced',
    overage: 'Overage',
    shortage: 'Shortage',
    amountMismatch: 'Amount Mismatch',
    platformAdvanceLogisticsFee: 'Return shipping fee(£)',
    shippingCostCompensation: 'Shipping compensation(£)',
    ownerSettlementAmount: 'Estimated settlement amount(£)',
    settlementAmount: 'Settlement amount(£)',
    actualOrderAmount: 'Actual order amount(£)',
    paymentAmount: 'Payment amount(£)',
    orderTransactionRecord: 'Order transaction record',
    settlementHandlingFee: 'Settlement Handling Fee',
    salesShippingTrackingNumber: 'Sales Shipping Tracking Number',
    expectedSettlementTime: 'Expected Settlement Time',
    unsettledReason: 'Unsettled Reason',
    shippingFee: 'Shipping Fee(£)',
    returnShippingTrackingNumber: 'Return Shipping Tracking Number',
    totalProductPrice: 'Total Product Price(£)',
    cardPaymentRefundFee: 'Card payment refund fee(£)',
    returnLossFee: 'Return Loss Fee(£/package)',
    packagingLaborFee: 'Packaging & Labor Fee(£/package)',
    deductionAmount: 'Deduction Amount',
    pendingSettleDesc: 'Completed orders with no return risk (14-day window passed) in the settlement cycle',
    settledDesc: 'Completed, return-free orders (14-day window passed) for the settlement cycle',
    settleCycle: 'Settlement Cycle'
  },
  terms: {
    conditions: 'Terms & Conditions',
    privacy: 'Privacy Policy',
    storeOpeningNotice: 'Merchant Store - Opening Guidelines',
    haveRead: 'I have read and agree to ',
    noReadTip: 'Please agree to the terms by checking the box to proceed.',
    and: 'and',
    sellerCodeOfConduct: 'Seller Code of Conduct',
  },
  afterSale: {
    sellerReviewDeadlinePrompt: 'The seller is required to complete the review by',
    noAction: 'If no action is taken by the deadline, it will be automatically approved.',
    timedOutStatus: '00:00:00',
    BuyerAppliesReturn: 'Buyer applies for a return',
    InProcessing: 'In processing',
    ReviewCompleted: 'Review completed',
    ReturnProcessing: 'Return in processing',
    BuyerInitiatesReturn: 'Buyer initiates a return request',
    AfterSalesInformation: 'After-sales Information',
    RefundAfterReceiptProducts: 'Refund after receipt of products',
    ProductsReceived: 'Products received',
    ProductsNotReceived: 'Products not received',
    AfterSalesNo: 'After-sales No.',
    ApplicationAmount: 'Application Amount',
    BuyerEntitledRefund: 'Buyer\'s Entitled Refund',
    AfterSalesReason: 'After-sales Reason',
    AfterSalesType: 'After-sales Type',
    ReceiptStatus: 'Receipt Status',
    ApplicationQuantity: 'Application Quantity',
    QuantityToReturn: 'Quantity of Items to Return',
    CustomerServiceArbitration: 'Platform Processing Result',
    Return: 'Return',
    TransactionInformation: 'Transaction Information',
    RefundRequestAmount: 'Refund Request Amount',
    sellerRefusedReturn: 'The seller refused the return',
    returnReviewApprovedAwaitingShip: 'Return Review Approved, awaiting buyer to ship',
    awaitingBuyerShip: 'Awaiting buyer to ship',
    awaitingSellerReceive: 'Awaiting seller to receive',
    afterSalesCompleted: 'After-sales Completed',
    ReturnShippingInfo: 'Return Shipping Info',
    ReturnShippingUpdates: 'Return Shipping Updates',
    buyerHasShipped: 'The buyer has shipped, the return item is in transit',
    ReturnRefund: 'Return & Refund',
    returnItemDeliveredAwaitingSign: 'Return item has been delivered, awaiting seller\'s signature',
    returnCompletedProceedRefund: 'Return has been completed, proceeding to refund process',
    noReturnOnlyRefundSuccessful: 'No return required, only refund has been successful',
    refundNumber: 'Refund Number',
    refundTime: 'Refund Time',
    buyerInitiatesOrderCancellation: 'Buyer initiates order cancellation',
    sellerReviews: 'Seller reviews',
    buyerSubmittedOrderCancellation: 'Buyer has submitted an order cancellation request',
    cancellationInProgressUrgeReview: 'Order cancellation request is in progress, please review it soon!',
    cancellationRequestApproved: 'Order cancellation request has been approved',
    cancellationApprovedProceedRefund: 'Order cancellation request has been approved and will proceed to the refund process',
    sellerRejectedCancellation: 'Seller has rejected the order cancellation',
    cancellationRequestRejected: 'Order cancellation request has been rejected',
    unshippedRefund: 'Unshipped Refund',
    AmountApplied: 'Amount Applied for Refund',
    RefundDestination: 'Refund Destination',
    requestedRefundAmount: 'Requested Refund Amount',
    actualRefundAmount: 'Actual Refund Amount',
    refundFromSellerToBuyer: 'Refund to the buyer from the seller\'s order payment',
    buyerPaymentMethod: 'Buyer\'s Payment Method',
    merchantPayoutMethod: 'Merchant Payout Method',
    productPayment: 'Product Fee',
    autoCancelOrderOnTimeout: 'Auto-Cancel Order on Timeout',
    autoConfirmReceiptPrompt: 'The order will be automatically confirmed as received after',
    receiptDueTime: '',  // 为空有用不要删
    ReturnAndRefundSupported: 'Return and refund supported',
    ReturnsRefundsNotSupported: 'Return and refund are not supported',
    GotoReview: 'Go to Review',
    reviewTimeoutAutoApproved: 'Review has timed out and is automatically approved',
    shipmentTimeoutAutoCancelled: 'Shipment has timed out, and the order has been automatically cancelled',
    orderAutoConfirmedReceipt: 'The order has been automatically confirmed as received',
    Type: 'Type',
    returnPath: 'Return Path',
    returnPathDetail: 'Buyer - Wallet - Balance',
    preOrderDepositDeduction: 'Pre-order Deposit Deduction',
  },
  entry: {
    settleProcess: "Select Onboarding Type",
    fillSettleInfo: "Complete Onboarding Information",
    welcomeIndividualMerchant: "Welcome Individual Merchants",
    fillSubmitInfo: "Please fill in the information and submit, we will review it as soon as possible.",
    enterpriseInfo: "Enterprise Information",
    registerNumVatTip: "For Registration No. and VAT No.,",
    fillAtLeastOne: "at least one item is required",
    otherwiseRejectAudit: "otherwise the review cannot be passed!",
    returnSelectOtherBizMode: "Return to select other business modes",
    shopName: "Shop Name",
    enterpriseName: "Enterprise Name",
    enterpriseNamePlaceholder: "Please enter the enterprise name",
    country: "Country",
    countryPlaceholder: "Select the enterprise country",
    registrationPlaceholder: "Please enter the enterprise registration number",
    vatPlaceholder: "Please enter the enterprise VAT number",
    eoriTaxNumber: "EORI Tax No.",
    eoriPlaceholder: "Please enter the UK EORI import/export tax number",
    eoriPlaceholderCn: "Please enter the EORI import/export tax number",
    vatRegistrationNum: "VAT No.",
    eoriNumber: "EORI No.",
    certificateFiles: "Certificate Files",
    certificateFilesHelp: "Corporate registration documents, VAT certificates or UK EORI import & export tax materials",
    certificateFilesHelpCn: "Corporate registration documents, VAT certificates or EORI import & export tax materials",
    contract: "Contract",
    contractTemplate: "Upload relevant contract files",
    downloadContractTemplate: "Download HURIX Shipper Service Contract Template",
    uploadFilesTip: "Upload relevant files (Image, PDF), up to 5 files",
    withdrawContract: "Contract",
    withdrawContractHelp: "Stamped cooperative business agreement for withdrawing revenue to mainland China bank accounts",
    withdrawContractUploadTip: "Upload the signed HURIX shipper service contract (PDF only)",
    withdrawContractHurix:'HURIX Shipper Service Contract',
    withdrawContractH:'Shipper Service Contract',
    personalInfo: "Personal Information",
    legalPersonInfo: "Legal Representative Information",
    ensureInfoAccurate: "Please ensure the information is accurate and correct",
    idProof: "ID Proof",
    idFullName: "Full Name on ID",
    submitAudit: "Submit for Review",
    submitFailed: "Submission Failed",
    prompt: "Prompt",
    submitSuccessTip: "Submission successful! The review result will be notified to you via email!",
    individualMerchant: "Individual Merchant",
    suitableForIndividual: "Individual Industrial and Commercial Household",
    settleNow: "Settle Now",
    approxThirtyMins: "Approx. 30 Minutes",
    operatorIdMaterials: ", operator ID documents, contract and other relevant qualification materials",
    queryMaterials: "Query Materials",
    platformAudit: "Platform Review",
    approxOneToThreeWorkdays: "Approx. 1-3 Working Days",
    platformAuditMaterials: "Platform reviews relevant qualification materials",
    enterpriseCompany: "Enterprise/Company",
    suitableForEnterprise: "Company/Enterprise/Individual-owned Enterprise, etc.",
    submitMaterials: "Submit Materials",
    uploadBizLicAndId: "Upload business license, legal representative ID documents, contract and other relevant qualification materials",
    accountVerification: "Account Verification",
    realNameOrCompanyPayVerify: "Real-name Verification or Corporate Account Payment Verification",
    "welcomeMerchant": "Welcome to settle in, company/enterprise operator",
    "threeInfoItems": "Registration No., VAT No., and EORI Tax No.: ",
    "hasAccount": "Already have an account? Log in now",
    "hasAccountS": "Already have an account?",
    "hasAccountLogin": "Log in now",
    "registerAccount": "Account Registration",
    "inputID": "Please enter your valid passport or UK driving license",
    "inputIDCn": "Please enter your valid passport or driving license",
    "inputIDCardCn": "Please enter your valid ID card",
    "nameConsistent": "Must match the name on your ID document",
    ukNoChineseAllowed: "When UK is selected, enterprise name and full name on ID cannot contain Chinese characters.",
    ukShopNameNoChineseAllowed: "When UK is selected, enterprise name cannot contain Chinese characters.",
    ukCertificateUsernameNoChineseAllowed: "When UK is selected, full name on ID can only contain English characters.",
    cnShopNameNoChineseAllowed: "When China is selected, enterprise name can only contain Chinese characters.",
    cnOnlyChineseAllowed: "When China is selected, the full name on ID can only contain Chinese characters.",
    "storeReviewing": "Your store platform is under review. The review result will be notified via email",
    "applicationRejected": "Your store application has been rejected. Do you want to resubmit the application?",
    checkTheInstruction: 'Please read and check the instructions',
    countrySelectBrand: 'Seller Central',
    countrySelectDefaultAccount: 'Seller',
    countrySelectAgreementPrefix: 'You authorize "Seller Central" and',
    countrySelectAgreementSuffix: 'to share your account ID and store name, and have read and agree to the',
    countryUkTitle: 'United Kingdom',
    countryCnTitle: 'China',
    countryEnter: 'Enter',
    countryNonUkTitle: 'Non-UK',
    countryNonUkSubtitle: 'Other Regions',
    registerSuccess: 'Account registration successful! ',
    registerFail: 'Registration failed',
    linkExpired: 'Link expired',
    operator: 'Operator',
    inviteOperator: 'Invite Operator',
    inviteOperatorByEmail: 'Invite new employees to {shopName} by email',
    sendInvite: 'Send invite',
    registered: 'Registered',
    linkTitle1: "The invitation link has expired",
    linkTitle2: "The link has expired",
    message1: "Sorry, the invitation link you visited is invalid or has expired. Please contact the main account to resend the invitation.",
    message2: "Sorry, the link you visited is invalid or has expired.",
    reasons_24: "The link has exceeded its 24-hour validity period",
    reasons_7: "The link has exceeded its 7 Days validity period",
    reasons2: "The sub-account has already completed registration",
    possibleReason: 'Possible Reason',
    invitationEmail: 'The operator will receive an invitation email.',
    bizSubjectTip1: "Suitable for enterprises, companies, brands, supply chains and other business entities",
    bizSubjectTip2: "Suitable for operators conducting business in personal capacity",
    corpNameTip: "Enterprise Name (Consistent with Business License)",
    corpRegNoLabel: "Enterprise Registration Number",
    corpRegNoPlaceholder: "Enter enterprise registration number (e.g. 12345678)",
    corpRegNoDesc: "Please enter the enterprise registration number issued by government / industry‑and‑commerce authority",
    regCountryArea: "Registered Country / Region",
    corpInfoTip: "Please fill in true enterprise information for platform review and compliance management",
    selectProvinceCityDistrict: "Please select Province / City / District",
    ukVatLabel: "UK VAT Number",
    ukVatPlaceholder: "Enter valid UK VAT Number (e.g. GB123456789)",
    ukVatDesc: "Please enter your VAT number registered with HMRC. The platform will perform quick verification",
    importantNote: "Important Note",
    vatVerifyTip1: "The platform will verify the validity of VAT number via HMRC system",
    vatVerifyTip2: "and determine whether the enterprise is UK‑based according to company registered address",
    vatEffectTip: "VAT information will affect subsequent tax handling rules of the platform",
    vatEffectTip3: "The withdrawal account must be consistent with the registered entity",
    contactPhonePlaceholder: "Please enter contact phone number",
    contactEmailPlaceholder: "Please enter contact email",
    contactPhoneLabel: "Phone Number",
    contactEmailLabel: "Contact Email",
    legalRepInfoTitle: "Legal Representative Information",
    legalRepKycTip: "For KYC identity verification",
    legalRepNameLabel: "Legal Representative Name",
    legalRepIdTypeLabel: "Legal Representative ID Type",
    legalRepIdNoLabel: "Legal Representative ID Number",
    legalRepIdUploadLabel: "Upload Legal Representative ID Document",
    legalRepNamePlaceholder: "Enter the legal representative's name as shown on the ID",
    idTypeSelectPlaceholder: "Please select ID type",
    idPortraitSide: "ID Portrait Side",
    idInfoSide: "ID Information Side",
    corpProofTitle: "Enterprise Entity Proof",
    requiredTag: "Required",
    companiesHouseLabel: "Company Registration Certificate (Companies House)",
    companiesHouseDesc: "Used to verify the entity information and registered address of the enterprise legally registered in the UK",
    supportFileTitle: "Supported Documents",
    incorporationFileTip: "Certificate of Incorporation / Companies House registration certificate (including company name, registration number, registration date, registered address)",
    ukVatCertLabel: "UK VAT Registration Certificate",
    ukVatCertDesc: "Used to verify the authenticity of VAT number and registered entity information",
    hmrcVatFileName: "HMRC VAT Registration Certificate / VAT Confirmation",
    supplementaryProofTitle: "Supplementary Supporting Documents",
    optionalTag: "Optional",
    companyConstitutionLabel: "Memorandum & Articles of Association",
    companyConstitutionDesc: "For further verification of corporate governance structure and business scope",
    companyConstitutionEnTip: "Memorandum & Articles of Association",
    businessAddrProofLabel: "Proof of Actual Business Address",
    businessAddrProofDesc: "To verify the company’s actual business address (if different from registered address)",
    businessAddrFileTip: "Bank statement / utility bill / commercial lease contract, etc. (must show company name & address, issued within 3 months)",
    bankAccountProofLabel: "Bank Account Proof",
    bankAccountProofDesc: "For verification of corporate bank account information",
    bankAccountFileTip: "Bank reference letter / bank statement (must show company name, account number or IBAN, issued within 3 months)",
    personalInfoTitle: "Personal Information",
    personalNameLabel: "Name (Consistent with ID Document)",
    birthDateLabel: "Date of Birth",
    nationalityAreaLabel: "Nationality / Region",
    personalNamePlaceholder: "Please enter your name",
    birthDatePlaceholder: "Please select date of birth",
    nationalityAreaPlaceholder: "Please select nationality / region",
    idVerifyTitle: "Identity Verification",
    idUploadTip: "Please upload valid government‑issued identity document",
    idTypeLabel: "ID Type",
    ukPassportOption: "UK Passport",
    ukDrivingLicenceOption: "UK Driving Licence",
    idUploadLabel: "Upload Identity Document",
    idFrontSide: "ID Front Side",
    idBackSide: "ID Back Side (if applicable)",
    selfieWithIdLabel: "Self‑photo holding ID document",
    holdIdSelfieUploadTip: "Please upload your selfie holding the ID document",
    selfieWithIdTip: "Please hold your ID document for photo, ensure document details are clearly visible.",
    residenceVerifyTitle: "Residential Address Verification",
    residenceVerifyTip: "Please upload one of the following residential address proof documents issued within the last 3 months",
    bankStatementItem: "Bank Statement (Last 3 Months)",
    bankStatementDesc: "Must include your full name, account information and transaction records.",
    utilityBillItem: "Utility Bill (Water / Electricity / Gas, Last 3 Months)",
    utilityBillDesc: "Must include your full name, address and bill date.",
    netMobileBillItem: "Internet / Mobile Phone Bill (Last 3 Months)",
    netMobileBillDesc: "Must include your full name, address and bill date.",
    rentalContractItem: "Rental Contract (Valid Period)",
    rentalContractDesc: "Must include your full name, address, lease term and signing date.",
    addressProofUploadLabel: "Upload Address Proof Document",
    salesChannelTitle: "Sales Channel Information",
    mainSalesChannelTip: "Please select your current main sales channels (multiple selections allowed)",
    channelIndependentSite: "Independent Website",
    channelOffline: "Offline Sales",
    channelOther: "Other",
    otherSalesChannelPlaceholder: "Please fill in other sales channels",
    shopLinkTip: "If you have an online store, please provide store link (optional)",
    shopLinkPlaceholder: "Please enter store link (e.g.: https://www.tiktok.com/@yourshop)",
    offlineBizTitle: "Offline Business Information (if applicable)",
    shopNameLabel: "Store Name (Optional)",
    shopNamePlaceholder: "Please enter store name",
    shopAddressLabel: "Store Address (Optional)",
    shopAddressPlaceholder: "Please enter store address",
    shopPhotoLabel: "Store Photos (Optional, max 5 images)",
    fileFormatSizeTip: "Supports JPG, PNG, PDF formats, file size no more than 10MB",
    uploadIdBothSideTip: "Please upload the portrait side and information side of the ID document",
    uploadCompaniesHouseTip: "Please upload Company Registration Certificate (Companies House)",
    uploadVatCertTip: "Please upload VAT Registration Certificate",
    uboTitle: "Ultimate Beneficial Owner (UBO)",
    uboTip: "Please provide the name of the ultimate beneficial owner if any natural person holds more than 25% equity or voting rights in your enterprise",
    uboNamePlaceholder: "Please enter name of ultimate beneficial owner",
    idPagePersonalInfo: "Personal Information Page",
    idPageSignature: "Personal Signature Page",
    drivingLicenceFront: "Driving Licence Front",
    drivingLicenceBack: "Driving Licence Back",
    proofFileTypePlaceholder: "Please select proof document type",
    vatTip1: "VAT invoices available",
    vatTip2: "VAT‑compliant settlement supported",
    vatTip3: "Full platform features access",
    vatTip4: "Personal Identity Verification",
    vatTip5: "Individual Business Entity Onboarding",
    vatTip6: "Provide VAT information as applicable",
    onboardTypeTip1: "Please select onboarding type",
    onboardTypeTip2: "Please select the onboarding type matching your business entity",
    tagRecommend: "Recommended",
    tagIndividualOnboard: "Individual Onboarding",
    nextStepFillInfo: "Next Step: Fill in Information",
    stepEnterpriseInfo: "Complete Enterprise Information",
    stepUploadQualification: "Upload Qualifications",
    stepOnboardSuccess: "Onboarding Successful",
    fileFormatTip: "Supports JPG, PNG, PDF formats. Maximum file size: 10MB",
    viewExample: "View Example",
    docRule1: "Documents must be clear and complete with no obstructions or glare",
    docRule2: "Content must be genuine and valid. Alteration or forgery is prohibited",
    docRule3: "Provide colour‑scanned copies or clear photos",
    docRule4: "Single file size must not exceed 10MB",
    docRule5: "Supports JPG, PNG, PDF formats",
    uploadReqTitle: "Upload Requirements",
    fileSampleTitle: "File Examples",
    faqTip1: "Click \"View Example\" to preview full‑size image",
    faqTitle: "Frequently Asked Questions",
    faqQ1: "Q: Is the latest Companies House certificate required?",
    faqA1: "A: Please provide up‑to‑date Companies House records updated within the last 3 months.",
    faqQ2: "Q: What if the registered address differs from the trading address?",
    faqA2: "A: Please also submit proof of your trading address for platform verification.",
    importantNoteTitle: "Important Notice",
    importantNoteDesc: "All documents must be genuine and valid with clear, fully‑visible information, free from obstructions and glare. Please provide colour‑scanned copies or clear, complete photographs. Submitted materials will be reviewed by the platform. False information may result in verification failure or account restrictions.",
    sloganText: "Compliant Operation · Win‑Win Integrity",
    onboardStep1: "Select Account Type",
    onboardStep2: "Business Information",
    onboardStep3: "Upload Documents",
    onboardStep4: "Platform Review",
    onboardStep5: "Onboarding Complete",
    complianceTipLabel: "Compliance Notice",
    complianceTipDesc: "To ensure platform transaction security and meet regulatory requirements, all sellers must complete real‑identity and enterprise information verification. HURIX will review your submitted information.",
    auditReviewStatus: "Under Review",
    auditSubmittedTitle: "Your application is under review",
    auditSubmittedDesc: "We are checking your business entity, identity, and qualification documents. The review is expected to be completed within 1–3 business days, and the result will be sent to your contact email.",
    auditMaterialNotice: "Documents are used only for onboarding review",
    auditAcknowledged: "Got It",

    store: {
      title: 'Associated Store Information (At Least One Required)',
      addStore: '+ Add More Stores',
      deleteStore: 'Delete Store',
      onlineStore: 'Online Store(optional to fill in)',
      platformType: 'Platform Type',
      platformTypePlaceholder: 'Please select a platform',
      storeUrl: 'Store Link',
      storeUrlPlaceholder: 'Please enter your store link',
      storeName: 'Store Name',
      storeNamePlaceholder: 'Please enter your store name',
      physicalStoreInformation: 'Physical store information(optional to fill in)',
      storeAddress: 'Store Address',
      storeAddressPlaceholder: 'Please enter your detailed store address',
      storeImage: 'Store Photos',
      hasPhysicalStore: 'I Have a Physical Store',
      noPhysicalStore: 'I Do Not Have a Physical Store',
      uploadImage: 'Click to Upload',
      chooseFile: 'Choose File',
      uploadImageTip: 'Images supported, up to 10 files',
      imageExample: 'Example: Storefront and interior photos'
    },

    validation: {
      platformType: 'Please select a platform type',
      storeUrl: 'Please enter the store link',
      storeName: 'Please enter the store name',
      storeAddress: 'Please enter the store address',
      storeImage: 'Please upload store photos',
      duplicateStore: "This store already exists.",
    },
  },
  verifyWithdraw: {
    currentPayee: 'Current Payee',
    alertBanner: 'To protect your funds, please verify the payee information first.',
    payeeInfo: 'Payee Information',
    payeeBankAccountInfo: 'Payee Bank Account Information',
    bankAccountName: 'Account Name',
    enterBankAccountName: 'Personal accounts must include middle name (if any). Business accounts must match the registered full name exactly, consistent with bank records.',
    firstName: 'First Name',
    enterFirstName: 'Please enter first name',
    lastName: 'Last Name',
    enterLastName: 'Please enter last name',
    companyRegistrationNumber: 'Company Registration No.',
    enterCompanyRegistrationNumber: 'Please enter the company registration number',
    legalRepresentativeName: 'Legal Representative Name',
    enterLegalRepresentativeName: 'Please enter the legal representative name',
    idNumber: 'ID Number',
    enterIdNumber: 'Please enter the ID number',
    payeeBankAccountNumber: 'Account Number',
    enterBankAccountNumber: 'Please enter the bank account number',
    bankName: 'Bank Name',
    enterBankName: 'Please enter bank name',
    enterBankNameToSearch: 'Please enter bank name',
    sortCode: 'Sort Code',
    enterSortCode: 'Please enter sort code',
    sortCodeError: 'Sort code must be in the format XX-XX-XX',
    cnapsCode: 'Branch Code (CNAPS)',
    enterCnapsCode: 'Please enter branch code (CNAPS) by phone bank',
    branchCode: 'Branch Code',
    enterBranchCode: 'Please enter branch code',
    enterBranchCodeShort: 'Please enter branch code',
    ukAccountNoError: 'Account number must be 7-8 digits',
    cnAccountNoError: 'Account number must be 12 digits',
    cnAccountNameOnlyChinese: 'Please enter with the full name on the bank account in Chinese',
    nonCnAccountNameNoChinese: 'Please enter with the full name on the bank account in English',
    nonCnBankNameNoChinese: 'Non-Chinese bank names cannot contain Chinese characters',
    remark: 'Remark',
    enterRemarkOptional: 'Please enter a remark (optional)',
    editWithdrawInfo: 'Edit Payee Info',
    createAccount: 'Create Account',
    fetchBankListFailed: 'Failed to fetch bank list',
    withdrawAmountTip: 'Only numbers greater than or equal to 0 are allowed.',
    feeTip: '* A transaction fee of {feeRate} will be deducted for withdrawals, with an estimated deduction of £{feeAmount}',

    feeTipFull: 'You are withdrawing <span class="fee-highlight">£{amount}</span>. A <span class="fee-highlight">{feeRate}</span> fee (approx. <span class="fee-highlight">{fee}</span>) will be deducted, leaving <span class="fee-highlight">{actualAmount}</span> credited to your account.Confirming this transaction indicates your acceptance of the fee. The actual deduction fee will be charged at the time of settlement based on the current exchange rate.',
    noChangesToSave: 'No information has been modified, no need to save',
  },
  myAccount: {
    withdrawContractInfo: 'Withdrawal Contract Information',
    withdrawContract: 'Withdrawal Contract',
    withdrawContractTemplateDownload: 'Download Contract Template'
  },
  wallet: {
    OtherCreditCardPayment: 'Other Credit Card Payment',
    CreditCardEnding: 'Credit card ending with cardNumber',
    OnlyVisaMastercard: 'Only Visa and Mastercard cards are supported',
    AddCreditCard: 'Add Credit Card',
    CardNumber: 'Card Number',
    CardholderName: 'Cardholder Name',
    CardHolder: 'Card Holder',
    ExpiryDate: 'Expiry Date',
    SecurityCode: 'Security Code(CVV)',
    checkCodeVisa: 'The three-digit code on the back of a credit or debit card is called the Card Verification Value (CVV) or Card Verification Code (CVC).',
    prefixOfCardNumber: 'The prefix of the card number must be 4, or in the range of 51-55, or in the range of 2221-2720.',
    lengthOfCardNumber: 'The length of the card number can only be 13 or 16.',
    EditCreditCard: 'Edit Credit Card',
    RemoveCreditCard: 'Remove Credit Card',
    sureRemoveCreditCard: 'Are you sure you want to remove this credit card? ',
    creditCardInformation: 'Credit Card Information',
    month: 'month',
    year: 'year',
    BillingAddress: 'Billing Address',
    editNewBillingAddress: 'Edit a New Billing Address',
    payNow: 'pay now',
    ShippingAddress: 'Shipping Address',
    Type: 'Type',
    SelectBillingAddress: 'Select a Billing Address',
    PleaseSelectBillingAddress: 'Please select a billing address',
    AllDataProtected: 'All data is protected',
    cardParameterError: 'Parameter error. Please verify your credit card information',
    CreditCard: 'Credit Card',
    transactionsAreSecureEncrypted: 'All transactions are secured and encrypted',
    sureUseCreditCard: 'Are you sure you want to use the credit card ending in cardNumber for payment?',
    CurrentBalance: 'Current Balance',
    AvailableBalance: 'Available Balance',
    FrozenAmount: 'Frozen Amount',
    TransactionHistory: 'Transaction History',
    WithdrawalProgress: 'Withdrawal in Progress',
    transferIn: 'Transfer In',
    withdrawal: 'Withdrawal',
    repurchase: 'Re-purchase',
    repurchaseRefund: 'Repurchase Refund',
    SerialNumber: 'Serial Number',
    TransactionID: 'Transaction ID',
    CreationDate: 'Creation Date',
    IncomeExpenseType: 'Income/Expense Type',
    Income: 'Income',
    Expense: 'Expense',
    TransactionType: 'TransactionType',
    BankCardNumber: 'Bank Card Number',
    WithdrawalRemarks: 'Withdrawal Remarks',
    WithdrawStatus: 'Withdrawal Status',
    WithdrawFailReason: 'Withdrawal Failure Reason',
    WithdrawStatus1: 'Created',
    WithdrawStatus2: 'Balance Recharging',
    WithdrawStatus3: 'FX Order Under Review',
    WithdrawStatus4: 'Withdrawing',
    WithdrawStatus5: 'Withdrawal Successful',
    WithdrawStatus6: 'Withdrawal Failed',
    ConfirmWithdrawal: 'Confirm Withdrawal',
    WithdrawAllFunds: 'Withdraw All Funds',
    surePayWithBalance: 'Are you sure you want to pay with your balance?',
    Balance: 'Balance',
    amountCannotBeZero: 'The withdrawal amount cannot be zero',
    amountMustBeGreaterThan50: 'The withdrawal amount cannot be less than 50',
    ConfirmPay: 'Confirm and pay',
    CVVMustDigits: 'Please enter your CVV, which must be 3 digits',
    ProcessingPayment: 'Processing Payment',
    committedProtectingInformation: 'HURIX is committed to protecting your payment information',
    paymentNotSuccessful: 'Your payment was not successful',
    cardIssuerDeclinedTransaction: 'Your card issuer has declined the transaction. Please contact your card issuer for further assistance or try another card or payment method.',
    wasNotCharged: 'Credit card was not charged',
    SomeCommonIssues: 'Some common issues and solutions:',
    VerifyPaymentInformation: 'Verify the payment information entered in your order',
    bankHaveFlagged: 'Your bank may have flagged this as unusual activity',
    withdrawalPurchaseLimits: 'Confirm your bank\'s daily withdrawal or purchase limits',
    PaymentSuccessful: 'Payment Successful',
    paymentStatusQuerying: 'Checking Payment Result...',
    paymentAmount: 'Payment amount',
    antoClose: 'Auto-closes after x s',
    bingCardTip: 'Card verification requires £1-£2 random payment. Amount will be added to your balance after verification.',
    bingCardTipSeller: 'The store [x] requires an adjustment. Please process it promptly.',
    bingCardTipOperator: 'The store [x] requires an adjustment. Contact seller.',
    bindNow: 'Adjustment Now',
    bankCard: 'Bank Card',
    setPaymentPassword: 'Set Payment Password',
    modifyPaymentPassword: 'Modify Payment Password',
    pleaseSetPaymentPasswordFirst: 'Please set your payment password first',
    goToSet: 'Go to Set Up',
    enterSixDigitPaymentPassword: 'Enter 6-digit payment password',
    pleaseEnterSixDigitPaymentPassword: 'Please enter your 6-digit payment password',
    paymentPasswordSetSuccess: 'Payment password set successfully!',
    pleaseEnterPaymentPassword: 'Please enter your payment password',
    forgotPaymentPassword: 'Forgot Payment Password?',
    preOrderRelease: 'Pre-order Release',
    preOrderDepositRefund: 'Pre-order Deposit Refund',
    preOrderExpiryRefund: 'Pre-order Expiry Refund',
    estimatedDebt: 'Estimated Debt Settlement',
    platformSettlement: 'Platform Settlement',
    platformSubsidies: 'Platform Subsidies - Other',
    pleaseEnterNewPaymentPassword: 'Please enter your new payment password',
    enterNewPaymentPassword: 'Enter new payment password',
    confirmNewPasswordAgain: 'Confirm the new password again',
    pleaseEnterOriginalPwdForModifyConfirm: 'Please enter your original payment password to confirm your password modification',
    modifyPaymentPasswordSuccess: 'Payment password updated successfully',
    enterValidBankCardNumber: 'Please enter a valid bank card number',
    deductionStatus: 'Deduction Status',
    success: 'Success',
    failed: 'Failed',
    deductionMethod: 'Deduction Method',
    paymentStatus: 'Payment Status',
    paymentProcessing: 'Processing',
    paymentSuccess: 'Success',
    paymentCancelled: 'Cancel',
    paymentFailed: 'Failed',
    failureReason: 'Failure Reason',
    myBankCard: 'My Bank Card',
    myBalance: 'My Balance',
    withdrawalAmount: 'Withdrawal Amount',
    currentSettlementCycle: "Current cycle: ",
    // 收款设置相关
    collectionSettings: 'Collection Settings',
    collectionSettingsSubtext: 'To receive payments through a new account, please update your collection account',
    collectionAccount: 'Collection Account',
    valid: 'Valid',
    invalid: 'Invalid',
    reviewing: 'Reviewing',
    pleaseVerifyPayeeInfo: 'Please verify payee information',
    payeeInfoUnderReview: 'Payee information under review, expected to be completed within 1 business day',
    update: 'Update',
    fullBankCardNumber: 'Full Bank Card Number',
    confirm: 'Confirm',
    failedToGetFullCardNumber: 'Failed to get full card number',
    failedToGetFullCardNumberRetry: 'Failed to get full card number, please try again later',
    operationFailedRetry: 'Operation failed, please try again later',
    // for collection settings
    noPayeeAccountInfo: 'No payee account information available',
    errorUpdatingPayee: 'Error updating payee information:',
    estimatedEarnings: "estimated earnings",
    estimatedEarning: "Estimated Earnings",
    estimatedDebtDetails: "Estimated Earnings",
    estimated: "Estimated debt",
    storeRent: "Store rent",
    storageFee: "Storage fee",
    currentPaymentIncludesProcessingFee: "A £x fee will be deducted. The net amount will be credited to your balance.",
    minimumPaymentAmount: "Minimum payment amount",
    minPriceCalculation: 'Minimum payment amount(£) = Estimated debt * 1.2 - Available balance',
    selectPaymentMethod: 'Please select payment method',
    hours: ':',
    minutes: ':',
    seconds: '',
    estimatedAdjustmentAmount: "Estimated Adjustment Amount",
    pendingAdjustment: "Pending Adjustment",
    adjustmentNote: "Funds will be added to your balance for withdrawal or deduction. ",
    welcomeMessage: 'Hello, welcome to WeChat Pay!',
    myCheckout: 'My Checkout',
    transactionNotice: 'Using instant transaction, the transaction will be closed ',
    afterClose: ' , please pay promptly!',
    openWechat: 'Open mobile WeChat',
    scanToPay: 'Scan to continue payment',
    qrExpired: 'QR code has expired',
    firstUseDownload: 'First-time users please download mobile WeChat',
    networkTimeout: 'Network timeout, please reload......',
    redirectNotice: 'seconds before redirecting',
    bankCardNumber: "Please enter a numeric-only bank card number within 18 digits",
    amount: "Amount",
  },
  authorized: {
    connectShopify: "Connect Shopify",
    afterSyncYouCan: 'After synchronization is completed, you can:',
    apiLimitPhenomenon: 'Phenomenon: Stops after synchronizing some products and prompts "API call frequency limit"',
    authorizationExpired: 'Authorization Expired',
    authorizationExpiredPhenomenon: 'Phenomenon: Prompt "Authorization expired" or "No permission to access" during synchronization',
    authorizationExpiredSolution: 'Solution: Re-authorize the third-party platform',
    authorizationExpiryReminder: 'Expires in dayNum days',
    authorizationInstructions: 'Authorization Instructions',
    authorizationManagementDescription: 'Authorization Management Instructions',
    authorizationManagementDetails: 'On this page, you can manage the authorization information of your TikTok, Amazon, Temu, and Shopify platforms.',
    authorizationManagementDetails2: 'After successful authorization, you can view and manage the information of authorized stores. Authorization data is securely stored, and you can revoke authorization at any time.',
    authorizationProcessing: 'Authorization is being processed, please wait patiently.',
    authorizationStatus: 'Authorization Status',
    authorizationTime: 'Authorization Time',
    authorize: 'Authorize',
    authorized: 'Authorized',
    authorizedStoreInfo: 'Authorized Store Information',
    avoidInvalidSync: 'Avoid Invalid Synchronization: Offline or prohibited products may no longer exist on the third-party platform',
    batchSyncGoods: 'Synchronize products in batches',
    cancelAuthSyncTip: 'Once authorization is cancelled, the system will stop processing products that are being synced!',
    cancelAuthorization: 'Revoke Authorization',
    checkInfoBeforeSync: 'Check if the product information on the third-party platform is accurate and complete before synchronization',
    checkNetworkConnection: 'Check if your network connection is normal',
    checkSyncRecord: 'You can view the real-time progress in the 【Product Sync Record】',
    collectMerchantFeedback: 'We are collecting merchant feedback and may add the function of customizing rules in the future.',
    complianceRequirements: 'Compliance Requirements: Ensure that products comply with laws, regulations and platform policies',
    confirmAuthorizationPrompt: 'You have not authorized the application yet. Go to authorize?',
    confirmErrorType: '1. Confirm Error Type',
    confirmRevokeAuthorization: 'Are you sure you want to revoke the authorization?',
    confirmStoreInfo: 'Confirm Store Information',
    confirmStoreInfoDesc: 'Please re-confirm the authorized store information. Failure to confirm the information will result in the malfunction of relevant functions such as order synchronization.',
    confirmSync: 'Confirm Sync',
    consumerRights: 'Consumer Rights and Interests: Provide complete product information to protect consumers\' right to know',
    contactTechSupport: 'If it fails multiple times, please contact technical support',
    crossBorderEcommercePlatform: 'Cross-Border Ecommerce Platform',
    dataConsistency: 'Data Consistency: Ensure that the product status on HURIX is consistent with that on the third-party platform',
    defaultRuleSystemPreset: 'The default value processing rules in the current version are system-presets and cannot be modified temporarily. These rules are designed based on:',
    ensureGoodsValidity: 'Ensure Product Validity: In-stock products represent ongoing sales with complete and valid information',
    faqTitle: 'Frequently Asked Questions (FAQs)',
    faqTitle1: 'How long does product synchronization take?',
    faqTitle2: 'Why are only in-stock products synchronized?',
    faqTitle3: 'Default Value Processing Rules',
    faqTitle4: 'Common Causes and Solutions for Synchronization Failures',
    faqTitle5: 'Why is it necessary to supplement product review materials?',
    faqTitle6: 'What to do if product information is incorrect after synchronization?',
    globalEcommercePlatform: 'Global Ecommerce Platform',
    goToAuthorize: 'Go to Authorize',
    goodsExpirationDesc: 'For products synchronized from third parties, the product expiration time is set to 1 year by default',
    goodsExpirationTime: 'Product Expiration Time',
    goodsQuantity: 'Product Quantity: The more products there are, the longer the synchronization will take',
    imageSize: 'Image Size: If synchronizing product images, the image size will affect the synchronization speed',
    incompleteInformation: 'Incomplete Information: Confirm if the product information on the third-party platform is complete',
    independentEcommercePlatform: 'Independent Ecommerce Platform',
    industryBestPractices: 'Industry Best Practices: Formulated in accordance with the general standards of the e-commerce industry',
    informationCompleteness: 'Information Completeness: HURIX requires complete product information to be listed for sale',
    inventoryError: 'Inventory Error: Confirm the inventory quantity on the third-party platform',
    maintainDataConsistency: 'Data Consistency: Maintain unified and standardized product information',
    manuallyAddOnHurix: 'Or manually add the product on HURIX',
    manuallyEditNeededGoods: 'Manually edit the products that need to be adjusted',
    manuallyModifyOnHurix: 'Manually Modify: Directly edit the product information on the HURIX Product Management page',
    merchantSku: 'Merchant SKU',
    merchantSkuDesc: 'HURIX\'s merchant SKU prioritizes using the third-party merchant SKU; if the merchant SKU acquisition fails, the third-party product ID is used as HURIX\'s merchant SKU',
    missingImages: 'Missing Images: Check if the third-party platform provides product images',
    needSyncOffSaleGoods: 'If you need to synchronize offline products, you can:',
    networkCondition: 'Network Condition: The speed of the network connection with the third-party platform',
    networkConnectionIssues: '2. Network Connection Issues',
    networkIssuesPhenomenon: 'Phenomenon: Synchronization progress gets stuck for a long time or reports a network error',
    noAuthorizedStoreTip: 'No authorized stores under this platform. Please go to the authorization page to bind stores first.',
    optimizeUserExperience: 'User Experience Optimization: Reduce the workload of merchants\' manual configuration',
    orderStatusSyncAfterAuth: 'One-click sync — get Ready to Ship orders instantly! The system automatically tracks all subsequent order statuses, enabling real-time data synchronization with third-party platforms.',
    partialPlatformMaterialEmpty: 'The product review materials of some third-party platforms may be empty. The reasons for needing supplementation are:',
    partialSuccess: 'Partial Success',
    pendingSync: 'Pending Sync',
    permanentAuthorization: 'Permanent Authorization',
    platformComplianceRequirements: 'Platform Compliance Requirements: Ensure compliance with the policy requirements of the HURIX platform',
    platformPolicyDifferences: 'Platform Policy Differences: Different platforms have different requirements for review materials',
    platformRestrictions: 'Platform Restrictions: API call frequency limits of some third-party platforms',
    preventiveMeasures: '3. Preventive Measures',
    priceError: 'Price Error: Check if the price on the third-party platform has been updated',
    priceSetting: 'Price Setting',
    priceSettingDesc: 'HURIX selling price and market reference price uniformly use the third-party product pricing',
    processing: 'Processing',
    productSync: 'Product Sync',
    reExecuteSyncOnHurix: 'Then, re-execute the synchronization operation on HURIX',
    reListOnThirdPlatform: 'First, re-list the product on the third-party platform',
    reSyncAfterUpdate: 'Re-synchronize: After updating the information on the third-party platform, re-execute the synchronization operation',
    reduceSingleSyncQuantity: 'Reduce the number of products synchronized in a single operation',
    referenceLink: 'Reference Link',
    referenceLinkDesc: 'The reference link uses the detail page link of the third-party product by default',
    regularlySyncGoods: 'Synchronize products regularly to ensure timely information updates',
    retrySyncLater: 'Retry the synchronization operation later',
    revokeAuthorizationSuccess: 'Authorization revoked successfully',
    saveModifications: 'After saving the modifications, the products will be displayed according to your settings',
    saveResources: 'Save Resources: Reduce unnecessary synchronization operations and improve efficiency',
    selectAuthorizedStore: 'Please Select Authorized Store',
    selectPlatform: 'Select Platform',
    selectPlatformPlaceholder: 'Please select a third-party platform',
    selectStore: 'Select Store',
    selectStorePlaceholder: 'Please select the corresponding platform store',
    selectThirdPartyPlatformForSync: 'Please select a third-party platform for order synchronization. For unauthorized platforms, authorize them first before proceeding',
    selectXItems: 'Selected x item(s)',
    setPriceInventoryAlerts: 'Set price/inventory change reminders to synchronize updates in a timely manner',
    shortVideoEcommercePlatform: 'Short-Video Ecommerce Platform',
    solutionMethods: '2. Solutions',
    step1Desc: 'The system only synchronizes currently on-sale products; offline or restricted products will not be synchronized to HURIX.',
    step1Title: 'Sync Only Listed/On-Sale Products',
    step2Desc: 'After products from third-party platform stores are synchronized to HURIX, they will all be in the draft status uniformly.',
    step2Title: 'Products will be automatically sent for draft after synchronization.',
    step3Desc: 'After synchronization is complete, sellers can go to 【Draft】to complete the remaining product attributes.',
    step3Title: 'Sellers Complete Product Information',
    storeId: 'Store ID',
    storeName: 'Store Name',
    sync100Goods: 'Synchronizing 100 products usually takes 5 to 8 minutes.',
    syncAlert: 'Some third-party platforms may provide incomplete product review documents. Please supplement and perfect these materials during product editing to guarantee successful listing.',
    syncAuthorizedStoreProducts: 'Product Sync Task Setup',
    syncAuthorizedStoreTips: 'Authorize third-party platform stores first, then sync products to HURIX. Support viewing historical sync records.',
    syncFailed: 'Sync Failed',
    syncFailureTroubleshoot: 'If synchronization fails, please troubleshoot according to the following steps:',
    syncGoodsInfoError: 'If there is an error in the product information after synchronization, please handle it according to the following steps:',
    syncProducts: 'Sync Products',
    syncRecords: 'Product Sync Record',
    syncResult: 'Sync Result',
    syncStatus: 'Sync Status',
    syncSuccess: 'Sync Successful',
    syncTime: 'Sync Time',
    syncTimeDepends: 'Synchronization time depends on the following factors:',
    syncTimeNormal: 'Under normal circumstances:',
    syncedOrders: 'Synced Orders',
    systemOnlySyncOnSale: 'The system only synchronizes in-stock/on-sale products, mainly based on the following considerations:',
    thirdPartyReturnImportantNote: 'Important Note',
    thirdPlatformRestrictions: '3. Third-Party Platform Restrictions',
    unauthorized: 'Unauthorized',
    viewSyncedGoods: 'View the synchronized products on the Product Management page',
    waitBeforeReSync: 'Wait for a period of time before re-synchronizing',
    fillShopifyDomain: 'Please enter your Shopify store address',
    shopifyDomainRule: 'Shopify store domain must not contain http/https. Example: xxx.myshopify.com',
    cancelAuthFail: "Failed to cancel authorization. Please check the store status or authorization status.",
    deleteAuthConfirm: "Confirm to delete store authorization?",
    storeAuthCancelFail: "Failed to cancel store authorization. You may delete the current store information. Delete now?",
    authCrossShop: "Authorize Cross-border Store",
    authLocalShop: "Authorize Local Store",
    crossBorder: "Cross-border",
    local: "Local",
    shopType: "Store Type",
    authExpire: "Authorization Expired",
    unlockTip: "Feature unlocking, coming soon",
    localStore: "Local Store",
    crossStore: "Cross-border Store",
  },
  financeBill: {
    title: 'Bills',
    status: 'Bill status',
    all: 'All',
    processing: 'Processing',
    paid: 'Paid',
    closed: 'Closed',
    createdAt: 'Bill creation time',
    createdFrom: 'Bill creation start date',
    endDate: 'End date',
    billId: 'Bill ID',
    billType: 'Bill type',
    reset: 'Reset filters',
    amountDue: 'Amount due',
    amountPaid: 'Amount paid',
    total: 'Total',
    purpose: 'Payment purpose',
    actions: 'Actions',
    viewDetails: 'View details',
    details: 'Bill details',
    empty: 'No content available',
    loadFailed: 'Failed to load bills. Please try again later.'
  },
  billManagement: {
    pageDescription: 'Manage your bills, settlements, and estimated liabilities, and view detailed financial information',
    estimatedEarnings: 'Estimated Earnings',
    estimatedEarningsDesc: 'View your estimated payout and full cost breakdown for this period.',
    pendingSettlementOrders: 'Pending Settlement Orders',
    pendingSettlementDesc: 'Order amounts not yet settled, including completed orders that have not yet met the settlement conditions',
    settledOrders: 'Settled Orders',
    settledOrdersDesc: 'Records of completed settlements, including settlement time, amount, and status',
    payableAmount: 'Payable Amount',
    payableAmountDesc: 'The amount currently required to be paid, including various fees and deduction details.'
  },
  editor: {
    uploadSuccess: 'Upload Successful',
    uploadFailed: 'Upload Failed',
    uploading: 'Uploading...',
    maxLengthExceeded: 'Maximum character limit exceeded: {max}',
    maxImagesExceeded: 'Maximum {max} images allowed',
    characters: 'characters',
    images: 'images',
    onlyEnglishAllowed: 'Only English letters are allowed',
    contentNotMeetRequirements: 'The content does not meet the requirements'
  },
  finance: {
    expectedNetSales: 'Estimated net sales',
    expectedShipping: 'Estimated shipping',
    expectedFees: 'Estimated fees',
    productCard: 'Product card',
    platformShipping: 'HURIX shipping fee',
    actualShippingHint: 'Actual shipping charges will follow the rate card.',
    estimatedShippingTip: 'Shipping charges are estimates. Actual charges follow the shipping rate card.',
    netSalesTip: 'The total transaction value after deducting all applicable seller discounts.',
    netShippingTip: 'Debits and credits related to shipping fees.',
    feesTip: 'Fees charged for using HURIX services, such as transaction fees and HURIX commission.',
    totalSalesTip: 'The total transaction value before deducting seller or HURIX discounts.',
    salesRefundsTip: 'The subtotal of refunded SKUs before applying seller discounts.',
    sellerDiscountsTip:
      'Seller discounts are seller-funded promotions, such as vouchers or product discounts.',
    discountRefundsTip: 'The discount amount refunded to the seller.',
    returnShippingTip: 'Shipping fees paid by the seller for return delivery.',
    returnShippingCompensationTip:
      'Platform-funded return shipping subsidies included in the free return service offered to customers.',
    commissionTip:
      'Commission is calculated as: (net sales + customer shipping fees - customer shipping fee refunds) × commission rate (%). Rates vary by product category. Commission is refunded proportionally for cancelled, returned or refunded orders.',
    logisticsTip:
      'A service fee charged on orders shipped through the seller’s own logistics carrier, for parcels that do not qualify for a fee exemption.',
    marketingTip: 'This fee includes funds from HURIX used to run promotions for customers.',
    overview: 'Overview',
    overviewDescription: 'Understand and manage shop payments and statements.',
    overviewTab: 'Financial overview',
    payments: 'Payments',
    statements: 'Statements',
    unsettled: 'Unsettled',
    invoice: 'Invoices',
    tabs: 'Finance tabs',
    all: 'All',
    paid: 'Paid',
    failed: 'Failed',
    processing: 'Processing',
    returned: 'Returned',
    paymentStatus: 'Payment status',
    status: 'Status',
    actions: 'Actions',
    viewDetails: 'View details',
    viewAll: 'View all',
    close: 'Close',
    cancel: 'Cancel',
    download: 'Download',
    export: 'Export',
    exportHistory: 'Export history',
    exportedReports: 'Exported reports',
    filename: 'File name',
    exportRange: 'Select the export date range',
    startDate: 'Start date',
    endDate: 'End date',
    exportRangeHint: 'Export up to 90 days of data at a time. View all reports in export history.',
    historyHint: 'Exported files are available for 24 hours. Export again after they expire.',
    noReports: 'No exported reports',
    noExportData: 'No data available in the selected date range',
    timezoneNotice: 'From 2025/10/23, reports use the time zone of your operating region.',
    searchPayout: 'Search payment ID',
    searchBill: 'Search statement ID',
    searchOrder: 'Search order / adjustment ID',
    selectPaymentDate: 'Select payment start date',
    selectSettlementDate: 'Select settlement date',
    selectCreatedDate: 'Select order creation date',
    selectStatus: 'Select status',
    selectType: 'Select type',
    selectReason: 'Select unsettled reason',
    selectExpectedAmount: 'Select estimated settlement amount',
    under100: 'Below £100',
    '100to500': '£100 to £500',
    over500: 'Above £500',
    paymentDetails: 'Payment details',
    paymentInfo: 'Payment information',
    payoutId: 'Payment ID',
    paymentAmount: 'Payment amount',
    paymentDate: 'Payment start date',
    paidDate: 'Paid date',
    reference: 'Attention',
    initiated: 'Payment initiated',
    bankConfirmed: 'Bank confirmed',
    noPayments: 'No payments',
    recentPayouts: 'Recent payouts',
    recentPayoutsTips: 'Payment records within the selected time period.',
    recentProcessing: 'Recent processing payouts',
    paymentsLoadFailed: 'Failed to load payments',
    statementsDescription:
      'Daily reports list settled order details, including revenue, refunds, fees and adjustments.',
    byBill: 'View by statement',
    byOrder: 'View by order',
    settledOrders: 'Settled orders',
    billId: 'Statement ID',
    settlementDate: 'Settlement date',
    settlementAmount: 'Settlement amount',
    breakdown: 'Settlement breakdown',
    netSales: 'Net sales',
    totalSales: 'Gross sales',
    shipping: 'Shipping',
    fees: 'Fees',
    adjustments: 'Adjustments',
    noBills: 'No statements',
    statementsLoadFailed: 'Failed to load statements',
    orderId: 'Order / adjustment ID',
    createdAt: 'Order creation date',
    deliveredAt: 'Order delivery date',
    order: 'Order',
    adjustment: 'Adjustment',
    skuName: 'SKU name',
    skuId: 'SKU ID',
    skuDetails: 'SKU details',
    noOrders: 'No matching orders / adjustments',
    product: 'Product',
    productName: 'Product name',
    quantity: 'Quantity',
    contentType: 'Content type',
    video: 'Video',
    unsettledDescription:
      'Unsettled amounts from recent orders. Actual amounts may change due to refunds, chargebacks or shipping adjustments.',
    unsettledDetails: 'Unsettled order details',
    expectedDate: 'Estimated settlement date',
    expectedAmount: 'Estimated settlement amount',
    reason: 'Unsettled reason',
    delivery: 'Awaiting delivery',
    refund: 'Awaiting refund / return completion',
    settlement: 'Delivered, awaiting settlement',
    afterDelivery: '{days} days after delivery',
    ordersLoadFailed: 'Failed to load unsettled orders',
    details: 'Details',
    settlementPaymentDate: 'Settlement date (payment start date)',
    commission: 'Platform commission',
    logistics: 'Logistics service fee',
    marketing: 'Smart marketing fee',
    grandTotal: 'Total settlement amount',
    breakdownTip: 'Refer to order details in the current statement for the exact amounts.',
    formula:
      'Total settlement = net sales + shipping + fees + adjustments. Refer to the statement for fee details.',
    learnCalculation: 'Learn how we calculate settlement amounts',
    noSettlementRecords: 'No settlement records',
    loadDetailsFailed: 'Failed to load settlement details. Please try again.',
    retry: 'Reload',
    ordersAndAdjustments: 'Orders and adjustments',
    missingBill: 'Statement not found. Return to Finance using the breadcrumb and select again.',
    financeDetailsFailed: 'Failed to load statement details. Please try again.',
    paymentCycle: 'Payment cycle',
    cycleDescription:
      'Choose your payment cycle. Weekly or monthly payments can simplify financial administration and reduce bank transactions.',
    cycleLearnMore:
      'Weekly payments are processed on the selected weekday. Monthly payments use the selected date, or the last valid day of a shorter month.',
    learnMore: 'Learn more',
    frequency: 'Frequency',
    daily: 'Daily',
    workday: 'Every business day',
    weekly: 'Weekly',
    monthly: 'Monthly',
    dailyDescription: 'Payments are processed every calendar day.',
    workdayDescription: 'Payments are processed Monday to Friday, excluding public holidays.',
    weeklyDescription: 'Payments are processed once a week on your selected weekday.',
    monthlyDescription:
      'Payments are processed once a month on your selected date. If that date does not exist in a month (for example, the 31st), payment is processed on the last valid day of that month.',
    recommended: 'Recommended',
    cycleDate: 'Date',
    searchCycleDate: 'Type to search',
    submit: 'Submit',
    cycleSaveFailed: 'Failed to save payment cycle. Please try again.',
    weeklyOn: 'Weekly ({day})',
    monthlyOn: 'Monthly (day {day})',
    weekday1: 'Monday',
    weekday2: 'Tuesday',
    weekday3: 'Wednesday',
    weekday4: 'Thursday',
    weekday5: 'Friday',
    weekday6: 'Saturday',
    weekday7: 'Sunday',
    custom: 'Custom',
    thisWeek: 'This week',
    lastWeek: 'Last week',
    lastMonth: 'Last month',
    paymentFrequency: 'Payment frequency',
    financialStatus: 'Financial status',
    netIncome: 'Net income',
    netIncomeTip: 'The amount you will receive after settling all platform fees. You can customize the payment schedule or use these funds to cover other platform expenses.',
    received: 'Received',
    receivedTip: 'The amount successfully transferred to the main bank account.',
    inProgress: 'Processing',
    processingEstimate: 'Estimated 1–3 business days',
    processingTip: 'The bank is processing your payment and it is expected to arrive in 1-3 business days.',
    toDate: 'To date',
    unsettledTip: 'The unsettled amount in recent orders. The actual amount may change due to refund requests, chargebacks, or freight adjustments.',
    currentCycleNotice:
      'Your current payment cycle is {frequency}. Consider the following to reduce potential balance risks:',
    cycleSuggestion:
      'Choose weekly or monthly payments to simplify financial administration and reduce bank transactions.',
    manageCycle: 'Manage payment cycle',
    recentBills: 'Recent statements',
    noContent: 'No data',
    recentPaymentHint: 'Recent payment information appears here.',
    dailyPaymentChart: 'Daily payment amounts',
    currentSettlementCycle: 'Current settlement cycle',
    settlementCycleTip:
      'The settlement cycle starts after delivery. Receipt dates depend on the actual settlement result.',
    deferredCycle: 'Deferred settlement cycle',
    unlockFaster: 'How to unlock faster payments',
    reserveLevel: 'Reserve level',
    level: 'Level {level}',
    reserveRules: 'Reserve usage rules',
    unsettledChart: 'Unsettled amounts by reason',
    paymentSettings: 'Payment settings',
    accountHint: 'To receive payments in a new settlement account, set it as the primary account.',
    settlementAccount: 'Settlement account',
    valid: 'Valid',
    learnFinance: 'Learn about finances',
    whenPaid: 'When will I receive payment?',
    whenPaidAnswer:
      'Once an order meets settlement conditions, payment is arranged according to your payment cycle. Banks usually take 1–3 business days, with possible delays over weekends and holidays.',
    commissionQuestion: 'How is platform commission calculated?',
    commissionAnswer:
      'Commission is calculated using the applicable order rate and settlement amount. Refunds, seller discounts and fee adjustments affect the final payment. View the period details in Statements.',
    overviewLoadFailed: 'Failed to load financial overview. Please try again.',
    salesRefunds: 'Sales refunds',
    sellerDiscounts: 'Seller discounts',
    discountRefunds: 'Seller discount refunds',
    netShipping: 'Net shipping',
    returnShipping: 'Return shipping',
    returnShippingCompensation: 'Return shipping compensation',
    awaitDelivery: 'Awaiting parcel delivery',
    awaitRefund: 'Awaiting return / refund completion',
    processingAmountTip: 'Payment initiated. Estimated arrival in 1–3 business days.',
    paidAmountTip: 'The payment amount is the total amount you ultimately receive after deducting all fees, adjustments, and reserve funds. When your daily payment amount is greater than or equal to £ 1.00, HURIX will initiate the payment.',
    paymentComposition: 'Payment amount breakdown',
    unsettledOrderInformation: 'Unsettled order information',
    noUnsettledOrders: 'No unsettled orders',
    pendingSettlement: 'Awaiting settlement',
    orderNumber: 'Order number',
    createDate: 'Creation date'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js